/* =========================================================
   LATAKAN, Catalogue, marketplace premium (light PLP)
   Sidebar a facettes + grille + pagination. Vanilla JS.
   Logos reels football-logos.cc + photos detourees (assets/jerseys/).
========================================================= */
(() => {
  'use strict';

  // filet de securite anti-FOUC : revele le contenu meme si init() traine (data lente, erreur JS amont).
  setTimeout(function () { document.documentElement.classList.add('cat-ready'); }, 2500);

  /* ----------------------------- utils ----------------------------- */
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const el = (h) => { const t = document.createElement('template'); t.innerHTML = h.trim(); return t.content.firstElementChild; };
  const debounce = (fn, ms = 90) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const eur = (n) => n.toFixed(2).replace('.', ',') + ' €';
  const hexRgb = (h) => { h = h.replace('#', ''); if (h.length === 3) h = h.split('').map(c => c + c).join(''); return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) }; };
  const lum = (h) => { const { r, g, b } = hexRgb(h); const a = [r, g, b].map(v => { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }); return .2126 * a[0] + .7152 * a[1] + .0722 * a[2]; };
  const readable = (bg) => (lum(bg) > .5 ? '#10141F' : '#FFFFFF');
  const blend = (a, b) => { const x = hexRgb(a), y = hexRgb(b), c = k => Math.round((x[k] + y[k]) / 2).toString(16).padStart(2, '0'); return '#' + c('r') + c('g') + c('b'); };

  /* ----------------------------- data ------------------------------- */
  const LOGO = 'https://assets.football-logos.cc/logos/';
  const LEAGUES = { l1: 'Ligue 1', pl: 'Premier League', liga: 'LaLiga', seriea: 'Serie A', bundes: 'Bundesliga', nations: 'Sélection', club: 'Club' };

  var TEAMS = (window.LATAKAN_TEAMS && window.LATAKAN_TEAMS.length) ? window.LATAKAN_TEAMS : [];
  const TEAM = Object.fromEntries(TEAMS.map(t => [t.id, t]));
  // COMPTEURS SERIALISES cote Liquid (catalogue fige) : products_count par handle d'equipe, connu du
  // serveur AVANT loadAll(). Source de verite IMMEDIATE pour la rangee clubs -> le vrai nombre s'affiche
  // des le 1er paint (plus de "... maillots"). Le compte LIVE (CB_CLUB, derive du catalogue charge) le
  // remplace silencieusement une fois loadAll() fini, mais les deux convergent (catalogue fige).
  const SCOUNTS = (window.LATAKAN_COUNTS && window.LATAKAN_COUNTS.clubs) ? window.LATAKAN_COUNTS.clubs : {};

  /* --------------------------- catalogue ---------------------------- */
  const SEASONS = ['2025/26', '2024/25', '2023/24', '2022/23'];
  const SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  // Union de toutes les tailles reellement presentes dans le catalogue charge.
  // Ordre : tailles ADULTES connues (S<M<L<XL<XXL) d'abord, puis tailles NUMERIQUES (enfant) en croissant.
  function availableSizes() {
    const seen = new Set();
    CATALOG.forEach(p => (p.sizes || []).forEach(s => { if (s != null && s !== '') seen.add('' + s); }));
    const list = [...seen];
    const adults = list.filter(s => SIZES.indexOf(s) >= 0).sort((a, b) => SIZES.indexOf(a) - SIZES.indexOf(b));
    const nums = list.filter(s => SIZES.indexOf(s) < 0 && /^\d+$/.test(s)).sort((a, b) => (+a) - (+b));
    const rest = list.filter(s => SIZES.indexOf(s) < 0 && !/^\d+$/.test(s)); // tailles non standard eventuelles, en fin
    const out = adults.concat(nums, rest);
    return out.length ? out : SIZES.slice();
  }

  // Categories (p.type) reellement presentes dans le catalogue, de la plus fournie a la moins fournie.
  // La facette "Categorie" est construite a partir de CETTE liste (et non d'une liste codee en dur) :
  // les vrais p.type viennent du tag "type:" cote serveur (repli "Maillot"), cf. catalog-product-json.liquid
  // -> valeurs reelles Maillot / Survetement / Maillot enfant / Maillot manches longues / Coupe-vent / Veste / Short.
  // L'ancienne liste Domicile/Exterieur/Troisieme/Entrainement ne correspondait a AUCUN produit -> 0 resultat.
  // Re-evalue a chaque buildSidebar ; completee en place par refreshTypeChips() au fil de loadAll().
  function availableTypes() {
    return Object.keys(CB_TYPE).sort((a, b) => (CB_TYPE[b] - CB_TYPE[a]) || a.localeCompare(b, 'fr'));
  }

  // noms FR des selections (les collections nations sont en anglais) -> affichage + recherche FR
  const NATION_FR = {
    brazil:'Brésil', england:'Angleterre', italy:'Italie', spain:'Espagne', germany:'Allemagne',
    france:'France', portugal:'Portugal', netherlands:'Pays-Bas', belgium:'Belgique', croatia:'Croatie',
    mexico:'Mexique', colombia:'Colombie', argentina:'Argentine', uruguay:'Uruguay', japan:'Japon',
    'south-korea':'Corée du Sud', usa:'États-Unis', 'united-states':'États-Unis', canada:'Canada',
    morocco:'Maroc', senegal:'Sénégal', algeria:'Algérie', tunisia:'Tunisie', egypt:'Égypte',
    nigeria:'Nigéria', ghana:'Ghana', cameroon:'Cameroun', 'south-africa':'Afrique du Sud',
    switzerland:'Suisse', austria:'Autriche', poland:'Pologne', denmark:'Danemark', sweden:'Suède',
    norway:'Norvège', scotland:'Écosse', wales:'Pays de Galles', ireland:'Irlande', greece:'Grèce',
    serbia:'Serbie', ukraine:'Ukraine', ecuador:'Équateur', peru:'Pérou', chile:'Chili', paraguay:'Paraguay',
    australia:'Australie', 'saudi-arabia':'Arabie Saoudite', qatar:'Qatar', iran:'Iran', china:'Chine',
    malaysia:'Malaisie', 'costa-rica':'Costa Rica', panama:'Panama', jamaica:'Jamaïque',
    'fifa-world-cup-cote-divoire':"Côte d'Ivoire", 'fifa-world-cup-new-zealand':'Nouvelle-Zélande',
    'fifa-world-cup-turkiye':'Turquie'
  };
  const teamLabel = t => (t.league === 'nations' && NATION_FR[t.id]) ? NATION_FR[t.id] : t.short;
  const teamFull  = t => (t.league === 'nations' && NATION_FR[t.id]) ? NATION_FR[t.id] : t.name;
  // Nombre de maillots d'une equipe, JAMAIS undefined et JAMAIS "...". Ordre de priorite :
  //  1) SCOUNTS[handle] : products_count REEL serialise cote Liquid -> connu des le 1er paint, exact.
  //  2) CB_CLUB[id] : compte LIVE derive du catalogue charge (peut etre partiel pendant loadAll).
  //  3) t.count (products_count embarque dans la tuile) puis 0.
  // Le serveur (SCOUNTS) prime : un vrai nombre s'affiche immediatement, sans attendre loadAll().
  const teamCount = t => (SCOUNTS[t.id] ?? CB_CLUB[t.id] ?? t.count ?? 0);
  // petite phrase sympa, variee par equipe (remplace le "Edition 2025/26" statique)
  function heroTagline(t) {
    const n = teamCount(t);
    const sets = t.league === 'nations'
      ? ['Porte les couleurs nationales', n + ' maillot' + (n > 1 ? 's' : '') + ' floqué' + (n > 1 ? 's' : '') + ' à ton nom', 'Sélection · flocage offert à ton nom', 'Tes couleurs, expédiées sous 14 jours']
      : [n + ' maillot' + (n > 1 ? 's' : '') + ' à floquer à ton nom', 'Flocage offert, expédié sous 14 jours', n + ' pièce' + (n > 1 ? 's' : '') + ' pour les vrais fans', 'Tes couleurs, livrées en 14 jours'];
    let h = 0; const s = String(t.id); for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return sets[h % sets.length];
  }

  // on n'embarque que les produits rattaches a une equipe connue (evite tout TEAM[p.team] indefini -> grille bloquee)
  // CATALOG RECHARGEABLE : le dump initial (250) est complete en AJAX par loadAll() -> tout le catalogue (>250).
  let _raw = [];
  const _seen = new Set();
  let CATALOG = [], CB_CLUB = {}, CB_MIN = {}, CB_SEASON = {}, CB_TYPE = {}, ALL_PLAYERS = [];
  function deriveCounts() {
    CB_CLUB = {}; CB_MIN = {}; CB_SEASON = {}; CB_TYPE = {};
    CATALOG.forEach(function (p) {
      CB_CLUB[p.team] = (CB_CLUB[p.team] || 0) + 1;
      if (CB_MIN[p.team] == null || p.price < CB_MIN[p.team]) CB_MIN[p.team] = p.price; // prix mini par equipe
      CB_SEASON[p.season] = (CB_SEASON[p.season] || 0) + 1;
      CB_TYPE[p.type] = (CB_TYPE[p.type] || 0) + 1;
    });
    ALL_PLAYERS = [...new Set(CATALOG.filter(function (p) { return p.player; }).map(function (p) { return p.player; }))];
  }
  function ingest() {
    CATALOG = _raw.filter(function (p) { return p.team && TEAM[p.team]; });
    CATALOG.forEach(function (p) { var t = TEAM[p.team]; if (t) { p.league = t.league; if (t.players) p.players = t.players; } });
    deriveCounts();
  }
  function addProducts(arr) {
    var n = 0;
    (arr || []).forEach(function (p) { if (p && p.id != null && !_seen.has(p.id)) { _seen.add(p.id); _raw.push(p); n++; } });
    if (n) ingest();
    return n;
  }
  addProducts(window.LATAKAN_CATALOG || []);

  /* --------------------------- cache catalogue ---------------------- */
  // CATALOGUE FIGE (import termine, ~4221 produits actifs) : on met en cache le resultat complet de
  // loadAll() dans localStorage. Au F5, si le cache est valide, on HYDRATE tout le catalogue
  // INSTANTANEMENT (plus d'attente des ~18 pages JSON), puis on revalide en arriere-plan (re-fetch +
  // maj cache si le total a change). Cle VERSIONNEE (bump CACHE_VER pour invalider apres un changement
  // de forme produit) + total embarque (invalide si le compteur serveur change) + TTL 24h.
  var CACHE_VER = 'v2';
  var CACHE_KEY = 'latakan_catalog_cache_' + CACHE_VER;
  var CACHE_TTL = 24 * 60 * 60 * 1000; // 24h
  // champs derives/redondants retires du cache (re-calcules ou re-fetch a la demande) :
  // - league + players : re-injectes par ingest() depuis l'equipe.
  // - url : non utilise (injectListLD reconstruit /?qv=<handle>).
  // - images : tableau redondant (= [img] en width:800) ; renderGallery retombe sur img, lazyGallery refetch.
  function trimForCache(p) {
    return {
      id: p.id, handle: p.handle, team: p.team, sub: p.sub, title: p.title, type: p.type,
      imgk: p.imgk, season: p.season, created: p.created, price: p.price, isNew: p.isNew,
      best: p.best, floc: p.floc, cdm: p.cdm, wc: p.wc, ldc: p.ldc, retro: p.retro,
      rating: p.rating, reviews: p.reviews, img: p.img, sizes: p.sizes, variants: p.variants
    };
  }
  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY); if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || !Array.isArray(c.products) || !c.products.length) return null;
      if (!c.ts || (Date.now() - c.ts) > CACHE_TTL) return null; // expire
      return c;
    } catch (e) { return null; }
  }
  function writeCache(products, total) {
    try {
      var payload = JSON.stringify({ ts: Date.now(), ver: CACHE_VER, total: total, products: products.map(trimForCache) });
      localStorage.setItem(CACHE_KEY, payload);
    } catch (e) { /* quota depasse / mode prive : on degrade silencieusement (fetch classique) */ }
  }
  // total embarque dans le cache au F5 precedent : sert a savoir si on a deja le catalogue complet
  // (on saute alors le re-render lourd a la fin de la revalidation si rien n'a change).
  var _cacheTotal = null;
  var _hydratedFromCache = false;
  (function hydrateFromCache() {
    var c = readCache(); if (!c) return;
    _cacheTotal = c.total != null ? c.total : c.products.length;
    if (addProducts(c.products)) _hydratedFromCache = true; // catalogue complet dispo des le 1er paint
  })();

  // TOTAL CONNU D'AVANCE (catalogue fige) : nombre reel de produits du catalogue complet, disponible
  // AVANT la fin de loadAll(). Sources, par ordre de fiabilite : le total embarque dans le cache du F5
  // precedent, sinon le total serialise depuis Liquid (window.LATAKAN_TOTAL = all_products_count). Sert
  // a afficher le VRAI compteur tout de suite dans la vue par defaut (tous les maillots) au lieu d'un
  // skeleton "Chargement..." pendant tout loadAll. Mis a jour quand loadAll connait le total exact (via
  // le champ "total" des pages catalogjson). Borne basse = ce qu'on a deja en memoire (jamais sous-vendre).
  var _knownTotal = (function () {
    var fromLiquid = (typeof window.LATAKAN_TOTAL === 'number' && window.LATAKAN_TOTAL > 0) ? window.LATAKAN_TOTAL : 0;
    return Math.max(_cacheTotal || 0, fromLiquid, 0) || null;
  })();

  // COMPTEUR STABILISE : tant que loadAll() n'a pas fini de charger TOUT le catalogue, on n'affiche PAS
  // de total partiel (qui "danserait" 250 -> 1609 -> 3969). render() montre alors un etat neutre
  // (skeleton) pour #resCount et les compteurs de la rangee clubs ; le vrai total ne s'affiche qu'une
  // fois le catalogue complet charge. CLS ~0 : le skeleton occupe la meme hauteur que le texte final.
  // HYDRATATION CACHE : si le cache a fourni le catalogue complet, on est deja "charge" -> pas de
  // skeleton, compteurs reels immediats. La revalidation reseau se fait quand meme en arriere-plan.
  let _loadingAll = !_hydratedFromCache;
  // charge le reste du catalogue en arriere-plan (pages JSON de 250) -> recherche + faceting couvrent TOUT le catalogue
  // REVALIDATION : si on a deja hydrate depuis le cache (_hydratedFromCache), la grille + les compteurs
  // sont deja complets ; on re-fetch quand meme TOUT en arriere-plan pour rafraichir le cache, mais on
  // ne declenche un re-render qu'a la fin et seulement si le total a change (pas de churn visuel).
  // recupere + parse une page catalogjson. Renvoie l'objet {page,pages,total,products} ou null.
  // PAS de header Accept:json (Shopify renverrait une 404 API au lieu de la vue Liquid).
  async function fetchCatalogPage(page) {
    try {
      var res = await fetch('/collections/all?view=catalogjson&page=' + page);
      if (!res.ok) return null;
      var data; try { data = JSON.parse(await res.text()); } catch (e) { return null; }
      if (!data || !data.products || !data.products.length) return null;
      return data;
    } catch (e) { return null; }
  }
  // rafraichissement EN PLACE apres ingestion d'un lot de pages (pas de wipe -> aucun flash).
  // render() reconcilie la grille par data-id, recountFacets() recale les compteurs.
  function refreshAfterBatch() {
    try { recountFacets(); refreshTypeChips(); refreshSizeChips(); refreshClubRow(false); render(); } catch (e) {}
  }

  async function loadAll() {
    // CHARGEMENT PARALLELISE (catalogue fige, ~17 pages de 250) : au lieu d'enchainer les fetches
    // sequentiellement (~5 s), on lance les pages par LOTS CONCURRENTS (le navigateur cappe a ~6
    // connexions par origine) -> chargement complet en ~1 s. On apprend d'abord pages+total via la
    // page 2, on affiche aussitot le vrai total, puis on tire le reste en concurrence.
    var CONC = 6;        // pages en vol simultanees (aligne sur le cap navigateur ~6/origine)
    var GUARD = 80;      // borne dure anti-boucle infinie
    var added = false;   // au moins un produit nouveau vu pendant ce loadAll
    try {
      // 1) page 2 d'abord : elle porte pages + total -> on connait tout de suite la taille du catalogue.
      var first = await fetchCatalogPage(2);
      if (first) {
        var pages = Math.min(first.pages || 1, GUARD);
        // TOTAL EXACT connu : on recale _knownTotal sur le total serveur reel et on rafraichit le
        // compteur immediatement (vue non filtree) -> le vrai nombre s'affiche des la 1re reponse.
        if (typeof first.total === 'number' && first.total > 0) {
          _knownTotal = Math.max(_knownTotal || 0, first.total);
          try { render(); } catch (e) {}
        }
        if (addProducts(first.products)) { added = true; refreshAfterBatch(); }
        // 2) pages 3..N en LOTS concurrents de CONC.
        for (var start = 3; start <= pages; start += CONC) {
          var batch = [];
          for (var pg = start; pg < start + CONC && pg <= pages; pg++) batch.push(fetchCatalogPage(pg));
          var results = await Promise.all(batch); // attend tout le lot (concurrence reelle dans le lot)
          var gotInBatch = false;
          results.forEach(function (data) { if (data && addProducts(data.products)) { added = true; gotInBatch = true; } });
          if (gotInBatch) refreshAfterBatch(); // un seul render par lot (pas par page) -> moins de churn
        }
      }
    } catch (e) { /* on garde ce qui est deja charge */ }
    // catalogue complet charge : on met a jour le cache localStorage (catalogue fige) pour le prochain F5.
    // On n'ecrit que si le re-fetch a abouti a un catalogue non vide (evite d'ecraser un bon cache par un
    // fetch reseau partiel/echoue). Le total embarque permet d'invalider si le compteur serveur evolue.
    try { if (_raw.length) writeCache(_raw, _raw.length); } catch (e) {}
    // catalogue complet charge : on quitte l'etat "chargement" -> les compteurs (resultats + clubs +
    // bannieres) affichent enfin leur valeur reelle et stable, en une seule fois (pas de danse).
    _loadingAll = false;
    // REVALIDATION SILENCIEUSE : si on avait hydrate depuis le cache ET que le re-fetch n'a rien ajoute
    // (total identique), la grille + compteurs sont deja a jour -> on saute le rafraichissement lourd
    // ci-dessous (aucun flash). On ne le fait que si le catalogue a reellement change (added).
    if (_hydratedFromCache && !added) { return; }
    // catalogue complet charge : un dernier rafraichissement EN PLACE (aucun wipe -> aucun flash).
    // - refreshTypeChips() ajoute les categories rares vues tard (Veste/Short) a la facette Categorie.
    // - refreshSizeChips() ajoute les tailles enfant nouvellement vues (16..28) a la facette Taille.
    // - refreshClubRow() met a jour les compteurs LIVE des tuiles club (ex. France 2 -> ~31) + reordonne.
    // - refreshCatCounts() recale le "+ de N maillots" des bannieres sur le vrai total.
    // - syncUI()/render() recalent l'etat et reconcilient la grille sans la vider.
    // On ne re-appelle PAS setupClubScroller() (eviterait de doubler les listeners) : un evenement resize
    // suffit a recalculer la visibilite des fleches du carrousel.
    try { refreshTypeChips(); recountFacets(); refreshSizeChips(); refreshClubRow(true); refreshCatCounts(); renderCollRow(); updateTopStats(); syncUI(); render(); window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  // "LDC 2026" = competition EN COURS : un maillot Ligue des Champions dont le titre porte une
  // saison anterieure a 2025/26 (ex "2005/06") est un RETRO -> il va dans la section Retro, pas ici.
  // Aucun millesime "AAAA/AA" dans le titre OU saison >= 2025 = considere actuel.
  const seasonCurrent = (title) => {
    const m = String(title || '').match(/(?:19|20)\d{2}\s*[\/\-]\s*\d{2}/);
    return !m || parseInt(m[0].slice(0, 4), 10) >= 2025;
  };
  // collections (chips + tuiles decouverte) : chacune = un predicat de filtre
  const COLLECTIONS = [
    { id: 'retro',      label: 'Rétro',              ic: '&#9201;', sub: 'Classiques cultes',   img: 'arsenal__retro', pred: p => p.retro },
    { id: 'ldc',        label: 'LDC 2026',           ic: '&#127942;', sub: 'Nuits européennes',   img: 'real__home',     pred: p => p.ldc && seasonCurrent(p.title) },
    { id: 'flocages',   label: 'Flocages',           ic: '&#128221;', sub: 'Floque ton nom',       img: 'barca__home',    pred: p => !!p.floc },
    { id: 'selections', label: 'Coupe du Monde 2026', ic: '&#127758;', sub: 'Coupe du monde 2026', img: 'fr__home',       pred: p => p.cdm },
    { id: 'limitées',   label: 'Éditions limitées',  ic: '&#128142;', sub: 'Séries rares',        img: 'psg__third',     pred: p => p.ltd }
  ];
  const COLL = Object.fromEntries(COLLECTIONS.map(c => [c.id, c]));
  const DISCOVER = ['retro', 'ldc', 'selections', 'flocages'].map(id => COLL[id]);

  // Libelle "+ de N maillots" pour les bannieres : N = taille reelle du catalogue, arrondie a la
  // centaine inferieure (jamais de sous-vente). Plancher a 3900 car la banniere se rend AVANT loadAll()
  // (CATALOG ne contient alors que le dump initial de 250) ; le vrai total (~3969) est ensuite
  // re-injecte en place par refreshCatCounts() en fin de loadAll(). Pas de tiret cadratin.
  function catalogCountLabel() {
    var n = Math.max(CATALOG.length, 3900);
    return '+ de ' + (Math.floor(n / 100) * 100);
  }
  function refreshCatCounts() {
    try { $$('[data-catcount]').forEach(function (s) { s.textContent = catalogCountLabel() + ' maillots disponibles'; }); } catch (e) {}
  }

  /* --------------------------- index recherche ---------------------- */
  const NICK = { real:['real madrid','madrid'], barca:['barca','barcelona'], om:['om','marseille'], psg:['paris','psg'], juve:['juve','juventus'], inter:['inter milan','inter'], milan:['ac milan','milan'], napoli:['napoli','naples'], bayern:['bayern','munich'], mancity:['city','man city'], manutd:['united','man utd'], atletico:['atletico','atleti'] };
  const SEARCH = [];
  TEAMS.forEach(t => {
    if (t.league === 'nations') {
      SEARCH.push({ kind: 'Sélection', label: teamFull(t), sub: 'Sélection nationale', team: t.id, apply: () => { setVals(state.clubs, t.id); state.collection = null; state.section = null; afterChange(); closeSuggest(); }, aliases: [t.name, teamFull(t), t.short, t.code] });
    } else {
      SEARCH.push({ kind: 'Club', label: t.name, sub: LEAGUES[t.league], team: t.id, apply: () => selectClub(t.id), aliases: [t.name, t.short, t.code].concat(NICK[t.id] || []) });
    }
    (t.players || []).forEach(([pl]) => SEARCH.push({ kind: 'Joueur', label: pl, sub: t.name, team: t.id, apply: () => { state.collection = null; state.section = null; setVals(state.clubs, t.id); setVals(state.players, pl); afterChange(); closeSuggest(); } }));
  });
  SEARCH.push({ kind: 'Collection', label: 'Rétro', sub: 'Classiques', apply: () => { setCollection('retro'); closeSuggest(); } });

  /* ----------------------------- crest / jersey --------------------- */
  // icones SVG pour les collections speciales (pas de logo de club) : Retro, Selections, LDC, Flocages, Editions limitees
  const ICON_SVG = {
    retro: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 1.5"/><path d="M5 4 3 6.5"/><path d="m19 4 2 2.5"/></svg>',
    selections: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
    ldc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10v4a5 5 0 0 1-10 0z"/><path d="M7 5H4v1.5a3 3 0 0 0 3 3M17 5h3v1.5a3 3 0 0 1-3 3"/><path d="M9.5 18h5M12 13v3"/></svg>',
    flocages: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>',
    'limitées': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.2l5.4-.8Z"/></svg>'
  };
  function crestHTML(o, cls = '') {
    if (ICON_SVG[o.id]) return `<span class="crest crest--ic ${cls}">${ICON_SVG[o.id]}</span>`;
    const mid = blend(o.c1, o.c2);
    // logos reels football-logos.cc, servis depuis les assets du theme.
    // PERF (LCP) : seul le crest de la BANNIERE hero (hb__crest, au-dessus de la flottaison) est en
    // loading="eager"+fetchpriority="high". Tout le reste (rangee clubs cchip, vedettes tn/cv, suggestions)
    // passe en loading="lazy" -> le navigateur ne telecharge ces ~100 logos que quand ils approchent du viewport
    // (-2,5 Mo sur le chargement initial). width/height fixes -> aucun CLS quel que soit le mode de chargement.
    // ANTI-FOUC : on affiche directement l'<img> du logo sur un fond placeholder neutre (pas de texte).
    // Le monogramme texte reste en display:none et n'est revele QUE si le logo echoue (onerror -> .crest.is-failed).
    // => on voit soit le logo directement, soit (echec) le monogramme, jamais le flash texte->image, meme en lazy.
    const eager = cls.indexOf('hb__crest') >= 0;
    // PERF (poids) : logos servis en WebP (qualite ~85, transparence conservee) = ~70% plus legers que le PNG.
    // Le src de base reste le .png fourni par le Liquid (asset_url versionne) ; on bascule l'extension sur .webp.
    // onerror -> repli PNG (data-png) une seule fois, puis monogramme si le PNG echoue aussi : aucune regression.
    const png = o.logoUrl || ('assets/logos/' + o.id + '.png');
    const webp = png.replace(/\.png(\?|$)/i, '.webp$1');
    const onerr = "if(this.dataset.png){var s=this.dataset.png;this.removeAttribute('data-png');this.src=s;}else{var c=this.parentElement;if(c){c.classList.add('is-failed');}this.remove();}";
    return `<span class="crest ${cls}"><span class="mono" aria-hidden="true" style="background:linear-gradient(135deg,${o.c1},${o.c2});color:${readable(mid)}">${o.code}</span><img alt="" aria-hidden="true" loading="${eager ? 'eager' : 'lazy'}"${eager ? ' fetchpriority="high"' : ''} decoding="async" width="256" height="256" src="${webp}" data-png="${png}" onerror="${onerr}"></span>`;
  }

  const SHIRT = 'M50 6 C44 6 40 9 34 9 L22 6 L6 20 L14 37 L26 31 L26 100 C26 104 33 106 50 106 C67 106 74 104 74 100 L74 31 L86 37 L94 20 L78 6 L66 9 C60 9 56 6 50 6 Z';
  function jersey(p) {
    const t = TEAM[p.team], c1 = t.c1, c2 = t.c2, uid = 'j' + p.id;
    const numCol = Math.abs(lum(c1) - lum(c2)) > .22 ? c2 : readable(c1);
    let pat = ''; const pt = t.pat || (['barca', 'juve', 'milan', 'inter', 'atletico'].includes(t.id) ? 'stripes' : 'plain');
    if (pt === 'stripes') for (let x = 14; x < 86; x += 16) pat += `<rect x="${x}" y="0" width="8" height="112" fill="${c2}"/>`;
    return `<svg class="jrs" viewBox="0 0 100 112" role="img" aria-label="${p.title}"><defs><clipPath id="${uid}"><path d="${SHIRT}"/></clipPath></defs><g clip-path="url(#${uid})"><rect width="100" height="112" fill="${c1}"/>${pat}</g><path d="${SHIRT}" fill="none" stroke="rgba(0,0,0,.16)" stroke-width="1.1"/><text x="50" y="84" text-anchor="middle" font-family="Archivo,sans-serif" font-weight="800" font-size="30" fill="${numCol}" opacity=".85">${[7,9,10,11][p.id % 4]}</text></svg>`;
  }
  function imgFor(p) { return p.img || (p.images && p.images[0]) || null; }

  /* ----------------------------- wishlist (store partage) ----------- */
  // Identite stable partagee avec core.js / la page wishlist (team|imgk|season|type|player)
  const Wish = window.LatakanWish;
  const wishKey = (p) => [p.team, p.imgk, p.season, p.type, p.player || ''].join('|');
  const badgeOf = (p) => p.retro ? 'retro' : p.best ? 'best' : p.isNew ? 'new' : p.ltd ? 'ltd' : '';
  const stockOf = (p) => { const r = (p.id * 37) % 100; if (r < 7) return { stock: 'out', lowN: 0 }; if (r < 19) return { stock: 'low', lowN: (p.id % 2) + 2 }; return { stock: 'in', lowN: 0 }; };
  const favSnap = (p) => { const st = stockOf(p); return { id: wishKey(p), team: p.team, imgk: p.imgk, season: p.season, type: p.type, title: cardTitle(p), price: p.price, img: imgFor(p) || '', badge: badgeOf(p), size: (p.sizes && p.sizes[0]) || 'M', stock: st.stock, lowN: st.lowN }; };

  /* ----------------------------- etat ------------------------------- */
  // state.collection = predicat de FILTRE grille (ex 'ldc' -> ne montre que les produits tagges ldc).
  // state.section    = CONTEXTE de vue competition persiste dans l'URL (?c=...). Decouple du filtre :
  //   quand on selectionne un club/pays vedette, on garde la section (LDC / Coupe du Monde) pour
  //   l'URL + la banniere + le retour F5, mais on vide collection pour que la grille montre TOUS les
  //   maillots du club (l'intersection ldc∩club serait vide, peu de produits etant tagges LDC).
  const state = { clubs: new Set(), seasons: new Set(), types: new Set(), players: new Set(), sizes: new Set(), price: null, q: '', collection: null, section: null, favOnly: false, sort: 'new', page: 1, pageSize: 12, view: 'grid' };
  // muter les Sets (jamais les reassigner) : les controles sidebar capturent la reference
  const setVals = (s, ...v) => { s.clear(); v.forEach(x => s.add(x)); };
  const SORTS = [{ id: 'new', label: 'Nouveautés' }, { id: 'best', label: 'Best sellers' }, { id: 'price-asc', label: 'Prix croissant' }, { id: 'price-desc', label: 'Prix décroissant' }];

  const body = document.body, grid = $('#grid'), pager = $('#pager');

  /* ----------------------------- filtres ---------------------------- */
  // Vue NON filtree = la grille montre l'INTEGRALITE du catalogue (aucune facette/recherche/collection
  // active). Dans ce cas, le total affiche = la taille du catalogue complet, connue d'avance (_knownTotal)
  // -> on peut afficher le vrai compteur immediatement, sans attendre loadAll().
  function isUnfiltered() {
    return !state.favOnly && !state.collection && !state.q
      && !state.clubs.size && !state.seasons.size && !state.types.size
      && !state.players.size && !state.sizes.size && !state.price;
  }
  function applyFilters() {
    let l = CATALOG.filter(p => {
      if (state.favOnly && !Wish.has(wishKey(p))) return false;
      if (state.collection && COLL[state.collection] && !COLL[state.collection].pred(p)) return false;
      if (state.clubs.size && !state.clubs.has(p.team)) return false;
      if (state.seasons.size && !state.seasons.has(p.season)) return false;
      if (state.types.size && !state.types.has(p.type)) return false;
      if (state.players.size && !(p.player && state.players.has(p.player))) return false;
      if (state.sizes.size && !(p.sizes && [...state.sizes].some(sz => p.sizes.includes(sz)))) return false;
      if (state.price && (p.price < state.price[0] || p.price > state.price[1])) return false;
      if (state.q) { const q = norm(state.q); const t = TEAM[p.team]; if (!norm([t.name, teamFull(t), p.title, p.type, p.season, LEAGUES[p.league], (p.players || []).map(pp => pp[0]).join(' '), (NICK[t.id] || []).join(' ')].join(' ')).includes(q)) return false; }
      return true;
    });
    const s = state.sort;
    if (s === 'price-asc') l.sort((a, b) => a.price - b.price);
    else if (s === 'price-desc') l.sort((a, b) => b.price - a.price);
    else if (s === 'new') l.sort((a, b) => (b.created || 0) - (a.created || 0));
    else if (s === 'best') l.sort((a, b) => (b.best || 0) - (a.best || 0) || b.heat - a.heat);
    else l.sort((a, b) => b.heat - a.heat);
    return l;
  }

  // Predicat "tous les filtres sauf une dimension" -> pour des compteurs de facette contextuels
  function matchExcept(p, except) {
    if (state.favOnly && !Wish.has(wishKey(p))) return false;
    if (except !== 'collection' && state.collection && COLL[state.collection] && !COLL[state.collection].pred(p)) return false;
    if (except !== 'clubs' && state.clubs.size && !state.clubs.has(p.team)) return false;
    if (except !== 'seasons' && state.seasons.size && !state.seasons.has(p.season)) return false;
    if (except !== 'types' && state.types.size && !state.types.has(p.type)) return false;
    if (except !== 'players' && state.players.size && !(p.player && state.players.has(p.player))) return false;
    if (except !== 'sizes' && state.sizes.size && !(p.sizes && [...state.sizes].some(sz => p.sizes.includes(sz)))) return false;
    if (except !== 'price' && state.price && (p.price < state.price[0] || p.price > state.price[1])) return false;
    if (state.q) { const q = norm(state.q); const t = TEAM[p.team]; if (!norm([t.name, teamFull(t), p.title, p.type, p.season, LEAGUES[p.league], (p.players || []).map(pp => pp[0]).join(' '), (NICK[t.id] || []).join(' ')].join(' ')).includes(q)) return false; }
    return true;
  }
  function tally(except, keyFn) { const m = Object.create(null); for (const p of CATALOG) { if (matchExcept(p, except)) { const k = keyFn(p); if (k != null) m[k] = (m[k] || 0) + 1; } } return m; }
  // Met a jour les compteurs affiches selon le contexte de filtrage courant
  function recountFacets() {
    const sb = $('#sideBody'); if (!sb) return;
    const bySeason = tally('seasons', p => p.season), byType = tally('types', p => p.type), byPlayer = tally('players', p => p.player), byClub = tally('clubs', p => p.team);
    $$('#sideBody .opt').forEach(o => {
      const inp = o.querySelector('input'), n = o.querySelector('.opt__n'); if (!inp || !n) return;
      const map = inp._set === state.seasons ? bySeason : inp._set === state.types ? byType : inp._set === state.players ? byPlayer : null;
      if (map) {
        const cnt = map[inp._value] || 0;
        n.textContent = cnt;
        // Masque l'option a 0 produit (sauf si elle est cochee) -> filtres plus aeres, pas d'option morte.
        o.style.display = (cnt > 0 || inp.checked) ? '' : 'none';
      }
    });
    $$('#sideBody .fchip').forEach(ch => { const n = ch.querySelector('.n'); if (n) n.textContent = byClub[ch.dataset.club] || 0; });
  }

  /* ----------------------------- carte ------------------------------ */
  // titre d'affichage carte : pas de prefixe "Maillot" (deja sous-entendu par le contexte),
  // categorie capitalisee -> "FC Barcelone Domicile 2025/26"
  function cardTitle(p) {
    let s = p.title.replace(/^Maillot\s+/i, '');
    return s.replace(/\s([a-zà-öø-ÿ][\wà-öø-ÿ'’-]*)(\s+\d{4}\/\d{2,4})$/, (m, w, y) => ' ' + w.charAt(0).toUpperCase() + w.slice(1) + y);
  }
  function card(p, eager) {
    const t = TEAM[p.team];
    const shot = imgFor(p);
    const loadAttr = eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"';
    // a11y : alt descriptif construit depuis le titre (ex "Maillot FC Barcelone Domicile 2025/26"),
    // jamais vide. cardTitle() retire un eventuel prefixe "Maillot" -> on le prefixe une seule fois.
    const alt = ('Maillot ' + cardTitle(p)).replace(/"/g, '&quot;');
    // Image = LE maillot sur fond blanc propre, en contain (tout le maillot visible). La star de la carte.
    const media = shot ? `<img class="shot" src="${shot}" alt="${alt}" ${loadAttr} decoding="async" width="640" height="800">` : jersey(p);
    const faved = Wish.has(wishKey(p)) ? 'is-on' : '';
    // note de marque : etoile doree + note en gras + nombre d'avis muted entre parentheses.
    // RIEN si le produit n'a aucun avis (0 avis) -> pas de "★ 0 (0)" disgracieux, juste le prix.
    const rate = (p.reviews | 0) > 0
      ? `<span class="card__rate" aria-label="Note ${p.rating} sur 5, ${p.reviews} avis"><span class="card__star" aria-hidden="true">★</span><b>${(p.rating + '').replace('.', ',')}</b><span class="card__rev">(${p.reviews})</span></span>`
      : '';
    // INDICATEUR NOMBRE DE TAILLES (remplace les chips S/M/L ou 16/18.. qui cassaient le responsive avec les tailles enfant).
    // Un seul element .card__sizecount (icone + "<N> tailles") ; le clic ouvre la vue rapide (meme handler que l'ancien
    // bouton). N = nombre de tailles du produit ; si 0 -> on n'affiche pas le bloc.
    const sizeN = (p.sizes && p.sizes.length) ? p.sizes.length : 0;
    const sizeCount = sizeN
      ? `<div class="card__sizes"><button class="card__sizecount" type="button" aria-label="${sizeN} taille${sizeN > 1 ? 's' : ''} disponible${sizeN > 1 ? 's' : ''}, voir le produit"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v5M15 8v3M19 8v3"/></svg><b>${sizeN}</b> taille${sizeN > 1 ? 's' : ''}</button></div>`
      : '';
    const c = el(`<article class="card" data-id="${p.id}">
      <div class="card__media">
        <button class="fav ${faved}" data-fav="${wishKey(p)}" aria-label="${faved ? 'Retirer des favoris' : 'Ajouter aux favoris'}" aria-pressed="${!!faved}"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-9.3-9A4.6 4.6 0 0 1 12 6a4.6 4.6 0 0 1 9.3 5C19 15.4 12 20 12 20Z"/></svg></button>
        ${media}
      </div>
      <div class="card__body">
        <div class="card__head"><span class="card__crest">${crestHTML(t)}</span><h3 class="card__title">${cardTitle(p)}</h3></div>
        <span class="card__sub">${p.sub}</span>
        <div class="card__foot"><span class="card__price">${eur(p.price)}</span>${rate}</div>
        ${sizeCount}
        <button class="card__add" type="button" aria-label="Ajouter au panier, choisir la taille et personnaliser"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span>Ajouter au panier</span></button>
        <p class="card__stock"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span><b>En stock</b> · Expédition sous 14 jours</span></p>
      </div></article>`);
    // image + titre -> acces produit (vue rapide, comportement existant) ; le coeur ne declenche pas la QV
    $('.card__media', c).addEventListener('click', e => { if (!e.target.closest('.fav')) openQV(p.id); });
    $('.card__head', c).addEventListener('click', () => openQV(p.id));
    $('.fav', c).addEventListener('click', () => toggleFav(p, $('.fav', c)));
    // indicateur de tailles -> ouvre la vue rapide (meme handler que l'ancien bouton taille/panier)
    const _sc = $('.card__sizecount', c); if (_sc) _sc.addEventListener('click', () => openQV(p.id, { floc: true }));
    // bouton "Ajouter au panier" -> ouvre le menu flocage (vue rapide), flocage deplie d'emblee
    $('.card__add', c).addEventListener('click', () => openQV(p.id, { floc: true }));
    return c;
  }

  /* ----------------------------- render ----------------------------- */
  function render() {
    const list = applyFilters();
    const total = list.length;
    // COMPTEUR DE RESULTATS : plus jamais de skeleton gris. On part d'un nombre plausible/exact des le
    // 1er paint et on ne le corrige qu'une fois, silencieusement (cf. bloc #resCount ci-dessous).
    const rc = $('#resCount');
    if (rc) {
      // COMPTEUR IMMEDIAT (catalogue fige) : PLUS JAMAIS de skeleton gris. On affiche toujours un NOMBRE
      // des le 1er paint, puis on ne le corrige qu'une fois, silencieusement (texte remplace seulement si
      // la valeur change vraiment -> aucun clignotement, aucune "danse").
      //  - Vue NON filtree : total final = taille du catalogue complet, connue d'avance (_knownTotal :
      //    cache du F5 precedent ou all_products_count serialise) -> on l'affiche tout de suite, exact.
      //  - Vue FILTREE : on affiche le total CALCULE sur les donnees deja chargees (selections/Coupe du
      //    Monde ~13 sont entierement dans le dump inline -> deja exact). Si un filtre plus large depasse
      //    le dump, loadAll() rappellera render() et le nombre montera UNE fois, en silence.
      var showCount = (isUnfiltered() && _knownTotal) ? Math.max(_knownTotal, total) : total;
      var nextHTML = `<b>${showCount}</b> maillot${showCount > 1 ? 's' : ''}`;
      // remplacement uniquement si le rendu change reellement (evite tout reflow/flicker inutile)
      if (rc.innerHTML !== nextHTML) rc.innerHTML = nextHTML;
    }
    const pages = Math.max(1, Math.ceil(total / state.pageSize));
    if (state.page > pages) state.page = pages;
    const start = (state.page - 1) * state.pageSize;
    $('#empty').hidden = total > 0;
    const pageItems = list.slice(start, start + state.pageSize);
    // RECONCILIATION KEYEE (anti-scintillement) : on ne vide PLUS la grille (grid.innerHTML='').
    // loadAll() appelle render() a chaque page JSON chargee -> un wipe+rebuild complet faisait
    // disparaitre puis reapparaitre toutes les cartes (flash). Ici on reutilise les cartes deja
    // presentes (par data-id), on ne cree que les nouvelles, on retire les disparues, et on
    // reordonne en place. Les <img> deja chargees restent -> aucun clignotement.
    const existing = new Map();
    for (const node of grid.children) existing.set(node.getAttribute('data-id'), node);
    const want = new Set(pageItems.map(p => String(p.id)));
    // retire les cartes qui ne doivent plus etre la
    existing.forEach((node, id) => { if (!want.has(id)) { node.remove(); existing.delete(id); } });
    // place chaque carte voulue dans l'ordre, en reutilisant l'existante ou en creant la manquante
    let ref = grid.firstChild;
    pageItems.forEach((p, i) => {
      const id = String(p.id);
      let node = existing.get(id);
      if (!node) node = card(p, state.page === 1 && i < 4);
      if (node === ref) { ref = ref.nextSibling; }       // deja a la bonne place
      else { grid.insertBefore(node, ref); }              // insere/deplace avant la position courante
    });
    renderPager(pages);
    syncContext(total);
    renderActiveFilters();
    injectListLD(pageItems);
    // PREFETCH PAGINATION : on precharge les images des pages ADJACENTES (suivante + precedente) en
    // temps mort -> "page suivante" est fluide (pas de pop d'images). Decale apres le 1er paint pour ne
    // jamais alourdir le chargement initial (idle callback). Fenetre glissante autour de la page courante.
    schedulePrefetch(list, pages);
  }

  /* -------------------- prefetch images pages adjacentes -------------- */
  // memoire des URLs deja preteechargees -> on ne relance jamais deux fois la meme image.
  var _prefetched = new Set();
  var _prefetchTimer = null;
  function prefetchImages(list, pages) {
    // pages adjacentes a la page courante (precedente + suivante) : fenetre glissante.
    var targets = [];
    if (state.page < pages) targets.push(state.page + 1);
    if (state.page > 1) targets.push(state.page - 1);
    var urls = [];
    targets.forEach(function (pg) {
      var s = (pg - 1) * state.pageSize;
      list.slice(s, s + state.pageSize).forEach(function (p) {
        var u = imgFor(p);
        if (u && !_prefetched.has(u)) { _prefetched.add(u); urls.push(u); }
      });
    });
    // garde-fou : on plafonne le nombre d'images preteechargees par passe (eviter une rafale enorme
    // si pageSize=48). Le reste sera repris au prochain render (changement de page).
    urls.slice(0, 60).forEach(function (u) { var im = new Image(); im.decoding = 'async'; im.src = u; });
  }
  function schedulePrefetch(list, pages) {
    if (pages <= 1) return;
    if (_prefetchTimer) { clearTimeout(_prefetchTimer); _prefetchTimer = null; }
    var run = function () { try { prefetchImages(list, pages); } catch (e) {} };
    // idle si dispo (ne concurrence pas le 1er paint), sinon petit delai.
    if (typeof window.requestIdleCallback === 'function') { window.requestIdleCallback(run, { timeout: 1200 }); }
    else { _prefetchTimer = setTimeout(run, 600); }
  }

  function renderPager(pages) {
    pager.innerHTML = '';
    if (pages <= 1) return;
    const mk = (label, pg, cls = '', dis = false) => { const b = el(`<button class="pg ${cls}">${label}</button>`); if (dis) b.disabled = true; else b.addEventListener('click', () => { state.page = pg; render(); const g = document.querySelector('.cat__bar') || grid; const y = g.getBoundingClientRect().top + scrollY - (innerWidth <= 860 ? 12 : 90); window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }); return b; };
    pager.appendChild(mk('<svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg>', state.page - 1, 'is-nav', state.page === 1));
    const win = []; const cur = state.page;
    win.push(1);
    for (let i = cur - 1; i <= cur + 1; i++) if (i > 1 && i < pages) win.push(i);
    if (pages > 1) win.push(pages);
    let prev = 0;
    [...new Set(win)].sort((a, b) => a - b).forEach(n => {
      if (n - prev > 1) pager.appendChild(el('<span class="pg-dots">...</span>'));
      pager.appendChild(mk(n, n, n === cur ? 'is-on' : ''));
      prev = n;
    });
    pager.appendChild(mk('<svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>', state.page + 1, 'is-nav', state.page === pages));
  }

  function afterChange() {
    // Synchronise la SECTION (contexte competition persiste) depuis le filtre collection courant.
    // Quand collection est active (ldc/selections/...), elle DEVIENT la section. Quand collection est
    // videe par une selection de club, on garde la section precedente (selectClub ne la touche pas) ;
    // les autres chemins qui sortent d'une competition (nav "Tous", colltab "Tous", reset, recherche,
    // "voir tous les clubs") posent explicitement state.section = null avant d'appeler afterChange.
    if (state.collection) state.section = state.collection;
    state.page = 1; syncUI(); render(); renderHeroBanner(); renderVedettes(); renderCollRow(); syncUrl();
  }

  // Persistance de la VUE competition dans l'URL (?c=) sans recharger : au F5 on reste sur la meme vue.
  // On persiste la SECTION (selections / ldc / retro / flocages / limitees / "tous") + le club/pays
  // selectionne le cas echeant (?c=<section>&club=<handle>), pour qu'un rechargement restaure la
  // section ET l'equipe. La recherche (?q=) / vue rapide (?qv=) restent intactes.
  let _urlReady = false; // l'init pose l'etat depuis l'URL : on n'ecrit pas avant pour ne pas ecraser un deep-link
  function syncUrl() {
    if (!_urlReady) return;
    try {
      const u = new URL(location.href);
      // une recherche ou un deep-link vue rapide a priorite : on ne touche pas a l'URL
      if (state.q || u.searchParams.get('q') || u.searchParams.get('qv')) return;
      // favoris : vue dediee sans contexte competition a persister
      if (state.favOnly) { u.searchParams.delete('c'); u.searchParams.delete('club'); }
      else {
        // section = contexte competition (ldc / selections / ...) ou 'all' par defaut
        u.searchParams.set('c', state.section || 'all');
        // un seul club/pays selectionne : on l'encode pour restaurer l'equipe au F5
        if (state.clubs.size === 1) u.searchParams.set('club', [...state.clubs][0]);
        else u.searchParams.delete('club');
      }
      history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
    } catch (e) {}
  }

  // Titre H1 / fil d'Ariane / badge contextuels (source de verite = state)
  function syncContext(total) {
    const f = state; let label;
    if (f.favOnly) label = 'Tes favoris';
    else if (f.q) label = `Résultats pour " ${f.q} "`;
    else if (f.collection && COLL[f.collection]) label = COLL[f.collection].label;
    else if (f.clubs.size === 1) label = 'Maillots ' + teamFull(TEAM[[...f.clubs][0]]);
    else if (f.clubs.size > 1) label = f.clubs.size + ' equipes selectionnees';
    else if (f.types.size === 1) label = 'Maillots ' + [...f.types][0].toLowerCase();
    else if (f.seasons.size === 1) label = 'Maillots saison ' + [...f.seasons][0];
    else label = 'Tous les maillots de football';
    const h1 = $('.titlerow__h'); if (h1 && h1.firstChild) h1.firstChild.textContent = label + ' ';
    const badge = $('#clubsBadge'); if (badge) badge.textContent = total + (total > 1 ? ' modèles' : ' modèle');
    // un seul span : sinon .btn (inline-flex gap:8px) ajoute un gap autour du <b> -> espaces bizarres
    const sa = $('#sideApply'); if (sa) sa.innerHTML = '<span>Voir les <b>' + total + '</b> maillots</span>';
  }

  // Chips de filtres actifs (visibles desktop ET mobile, retrait granulaire)
  function priceLabel(pr) { const mn = pr[0] || 0, mx = pr[1]; return mx >= 9999 ? `Plus de ${mn} euros` : `${mn} a ${mx} euros`; }
  function renderActiveFilters() {
    const box = $('#activeFilters'); if (!box) return; box.innerHTML = '';
    const chips = [];
    if (state.favOnly) chips.push(['Favoris', () => { state.favOnly = false; }]);
    if (state.collection && COLL[state.collection]) chips.push([COLL[state.collection].label, () => { state.collection = null; state.section = null; }]);
    [...state.clubs].forEach(id => chips.push([TEAM[id] ? TEAM[id].name : id, () => state.clubs.delete(id)]));
    [...state.seasons].forEach(s => chips.push(['Saison ' + s, () => state.seasons.delete(s)]));
    [...state.types].forEach(ty => chips.push([ty, () => state.types.delete(ty)]));
    [...state.players].forEach(pl => chips.push([pl, () => state.players.delete(pl)]));
    [...state.sizes].forEach(sz => chips.push(['Taille ' + sz, () => state.sizes.delete(sz)]));
    if (state.price) chips.push([priceLabel(state.price), () => { state.price = null; }]);
    if (state.q) chips.push([`" ${state.q} "`, () => { state.q = ''; qInput.value = ''; }]);
    box.hidden = chips.length === 0;
    chips.forEach(([label, remove]) => {
      const b = el(`<button class="afilter" type="button">${label}<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`);
      b.setAttribute('aria-label', 'Retirer le filtre ' + label);
      b.addEventListener('click', () => { remove(); afterChange(); });
      box.appendChild(b);
    });
    if (chips.length > 1) {
      const clr = el('<button class="afilter afilter--clear" type="button">Tout effacer</button>');
      clr.addEventListener('click', resetAll);
      box.appendChild(clr);
    }
  }

  // Donnees structurees : ItemList de la page courante (rich results)
  function injectListLD(items) {
    const origin = (location.origin && location.origin !== 'null') ? location.origin : '';
    const list = items.map((p, i) => {
      const t = TEAM[p.team];
      // Les fiches /products/* sont desactivees (redirect + noindex) -> on pointe l'url du ListItem vers le
      // deep-link vue rapide (/?qv=<handle>), coherent avec le parcours reel (la QV s'ouvre a l'arrivee).
      const url = p.handle ? (origin + '/?qv=' + encodeURIComponent(p.handle)) : undefined;
      const item = {
        '@type': 'Product', name: p.title, category: p.type,
        brand: { '@type': 'Brand', name: t.name },
        image: (origin ? origin + '/' : '') + (imgFor(p) || ''),
        offers: { '@type': 'Offer', price: p.price.toFixed(2), priceCurrency: 'EUR', availability: 'https://schema.org/InStock' }
      };
      // aggregateRating UNIQUEMENT si le produit a de vrais avis : un ratingValue/reviewCount a 0 est
      // invalide pour Google (rich result en erreur) et reviendrait a inventer une note. Coherent avec
      // le masquage du bloc note 0 avis sur la carte et en QV.
      if ((p.reviews | 0) > 0) item.aggregateRating = { '@type': 'AggregateRating', ratingValue: p.rating, reviewCount: p.reviews };
      if (url) item.url = url;
      const li = { '@type': 'ListItem', position: i + 1, item };
      if (url) li.url = url;
      return li;
    });
    const ld = { '@context': 'https://schema.org', '@type': 'ItemList', name: 'Maillots de football Latakan', numberOfItems: list.length, itemListElement: list };
    let s = document.getElementById('ld-list');
    if (!s) { s = document.createElement('script'); s.type = 'application/ld+json'; s.id = 'ld-list'; document.head.appendChild(s); }
    s.textContent = JSON.stringify(ld);
  }

  /* ----------------------------- club row --------------------------- */
  // Selectionne un club/pays : la GRILLE montre TOUS ses maillots (collection videe, sinon
  // l'intersection ldc∩club serait vide), mais on CONSERVE state.section pour garder le contexte
  // de competition (LDC / Coupe du Monde) dans l'URL + banniere + restauration F5.
  function selectClub(id) { state.collection = null; state.favOnly = false; setVals(state.clubs, id); afterChange(); closeSuggest(); }
  // COMPTEUR CLUB IMMEDIAT (catalogue fige) : teamCount() prime sur SCOUNTS[handle] (products_count reel
  // serialise cote Liquid) -> le VRAI nombre s'affiche des le 1er paint, plus jamais de "... maillots".
  // Le compte est deja exact cote serveur (catalogue fige) : aucune danse, aucune correction visible.
  function clubCountTxt(t) { const n = teamCount(t); return n + ' maillot' + (n > 1 ? 's' : ''); }
  function renderClubRow() {
    const row = $('#clubRow'); if (!row) return;
    row.innerHTML = ''; // idempotent : peut etre re-rendu apres loadAll() pour rafraichir les compteurs LIVE
    // Tri par compte REEL (teamCount -> SCOUNTS serialise) : ordre correct ET stable des le 1er paint,
    // sans attendre loadAll() (CB_CLUB serait partiel). On affiche toute equipe ayant >0 maillot serveur.
    [...TEAMS].filter(t => teamCount(t) > 0).sort((a, b) => teamCount(b) - teamCount(a)).forEach(t => {
      const c = el(`<button class="cchip" data-club="${t.id}"><span class="cchip__logo">${crestHTML(t, 'cchip__crest')}</span><span class="cchip__txt"><span class="cchip__name">${teamLabel(t)}</span><span class="cchip__count">${clubCountTxt(t)}</span></span></button>`);
      c.dataset.q = norm([t.name, teamLabel(t), t.short, (NICK[t.id] || []).join(' ')].join(' '));
      c.addEventListener('click', () => selectClub(t.id));
      row.appendChild(c);
    });
  }
  // Rafraichit la rangee clubs SANS la reconstruire (anti-scintillement post-loadAll).
  // Met a jour le compteur de chaque chip existante, ajoute les chips des equipes nouvellement
  // peuplees, puis reordonne les noeuds en place par nombre de maillots (deplacement, pas de wipe).
  function refreshClubRow(reorder) {
    const row = $('#clubRow'); if (!row) return;
    const byId = new Map([...row.children].map(n => [n.dataset.club, n]));
    [...TEAMS].forEach(t => {
      let c = byId.get(t.id);
      if (!c) {
        if (!teamCount(t)) return; // equipe sans maillot (compte serveur reel) : pas de chip
        c = el(`<button class="cchip" data-club="${t.id}"><span class="cchip__logo">${crestHTML(t, 'cchip__crest')}</span><span class="cchip__txt"><span class="cchip__name">${teamLabel(t)}</span><span class="cchip__count">${clubCountTxt(t)}</span></span></button>`);
        c.dataset.q = norm([t.name, teamLabel(t), t.short, (NICK[t.id] || []).join(' ')].join(' '));
        c.addEventListener('click', () => selectClub(t.id));
        row.appendChild(c);
        byId.set(t.id, c);
      } else {
        // pendant le chargement : on garde le placeholder neutre (pas de danse). En fin de loadAll
        // (_loadingAll=false), on pose le vrai compte stable.
        const cnt = c.querySelector('.cchip__count'); if (cnt) cnt.textContent = clubCountTxt(t);
      }
    });
    // reorder=true (1 seule fois, en fin de loadAll) : reordonne en place par compteur decroissant
    // (deplacement de noeuds, aucune carte ne disparait). Pendant la boucle on ne reordonne pas pour
    // eviter tout sautillement des chips a chaque page chargee.
    if (reorder) [...row.children]
      .sort((a, b) => (teamCount(TEAM[b.dataset.club] || {}) || 0) - (teamCount(TEAM[a.dataset.club] || {}) || 0))
      .forEach(n => row.appendChild(n));
  }
  // Ajoute en place les tailles nouvellement disponibles (apres loadAll) sans reconstruire la sidebar.
  function refreshSizeChips() {
    const box = $('#sideBody .chiprow'); if (!box) return;
    const have = new Set([...box.children].map(b => b.textContent.trim()));
    availableSizes().forEach(s => {
      if (have.has(s)) return;
      const b = el(`<button class="szchip ${state.sizes.has(s) ? 'is-on' : ''}">${s}</button>`);
      b.addEventListener('click', () => { b.classList.toggle('is-on'); if (state.sizes.has(s)) state.sizes.delete(s); else state.sizes.add(s); afterChange(); });
      box.appendChild(b);
    });
  }
  // Ajoute a la facette "Categorie" les types (p.type) nouvellement vus apres loadAll (ex. Veste/Short,
  // categories rares parfois absentes du dump initial de 250) -> meme principe que refreshSizeChips.
  function refreshTypeChips() {
    const body = $('#sideBody .facet[data-facet="type"] .facet__body > div'); if (!body) return;
    const have = new Set([...body.querySelectorAll('.opt input')].map(i => i._value));
    availableTypes().forEach(t => {
      if (have.has(t)) return;
      body.appendChild(optRow(state.types, t, t, CB_TYPE[t]));
    });
  }
  // rangee clubs : scroll fluide (fleches + molette + glisser) + recherche de marque
  function setupClubScroller() {
    const row = $('#clubRow'); if (!row) return;
    const scroller = row.closest('.clubrow__scroller');
    const prev = $('#clubRowPrev'), next = $('#clubRowNext'), empty = $('#clubRowEmpty'), search = $('#clubSearch');
    const STEP = () => Math.max(180, Math.round(row.clientWidth * 0.8));
    function updateArrows() {
      const max = row.scrollWidth - row.clientWidth - 1;
      const hasPrev = row.scrollLeft > 4, hasNext = row.scrollWidth > row.clientWidth + 4 && row.scrollLeft < max;
      if (scroller) { scroller.classList.toggle('has-prev', hasPrev); scroller.classList.toggle('has-next', hasNext); }
      if (prev) prev.hidden = !hasPrev;
      if (next) next.hidden = !hasNext;
    }
    if (prev) prev.addEventListener('click', () => row.scrollBy({ left: -STEP(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => row.scrollBy({ left: STEP(), behavior: 'smooth' }));
    row.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    // molette verticale -> defilement horizontal
    row.addEventListener('wheel', e => {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      const max = row.scrollWidth - row.clientWidth - 1;
      if ((e.deltaY < 0 && row.scrollLeft <= 0) || (e.deltaY > 0 && row.scrollLeft >= max)) return;
      e.preventDefault(); row.scrollLeft += e.deltaY;
    }, { passive: false });
    // glisser-deposer a la souris (desktop)
    let down = false, startX = 0, startL = 0, moved = false;
    row.classList.add('is-grab');
    row.addEventListener('pointerdown', e => { if (e.pointerType === 'touch') return; down = true; moved = false; startX = e.clientX; startL = row.scrollLeft; });
    row.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - startX; if (!moved && Math.abs(dx) > 4) { moved = true; row.classList.add('is-grabbing'); try { row.setPointerCapture(e.pointerId); } catch (_) {} } if (moved) row.scrollLeft = startL - dx; });
    const end = () => { down = false; row.classList.remove('is-grabbing'); };
    row.addEventListener('pointerup', end); row.addEventListener('pointercancel', end);
    // un glissement ne doit pas selectionner un club
    row.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // recherche centrale : vraie recherche sur la grille (club / joueur / saison / pays via state.q)
    // + filtrage en direct de la rangee de chips pour le repere visuel.
    if (search) {
      const runGridSearch = debounce(() => {
        const v = search.value.trim();
        // reset des filtres comme la recherche d'en-tete -> la grille reflete vraiment la requete
        [state.clubs, state.seasons, state.types, state.players, state.sizes].forEach(s => s.clear());
        state.collection = null; state.section = null; state.favOnly = false; state.price = null;
        state.q = v;
        afterChange();
      }, 220);
      search.addEventListener('input', () => {
        const q = norm(search.value); let shown = 0;
        $$('.cchip', row).forEach(ch => { const hit = !q || (ch.dataset.q || '').includes(q); ch.style.display = hit ? '' : 'none'; if (hit) shown++; });
        if (empty) empty.hidden = shown > 0;
        row.scrollLeft = 0; updateArrows();
        runGridSearch();
      });
    }
    // exemples cliquables sous la barre : chacun lance la recherche correspondante
    $$('.hsearch__chip').forEach(chip => chip.addEventListener('click', () => {
      const ex = chip.dataset.ex;
      if (search) search.value = '';
      // chaque exemple = une recherche propre et independante : on repart d'un etat neutre
      [state.clubs, state.seasons, state.types, state.players, state.sizes].forEach(s => s.clear());
      state.collection = null; state.section = null; state.favOnly = false; state.price = null; state.q = '';
      if (ex === 'club' && chip.dataset.club) { setVals(state.clubs, chip.dataset.club); afterChange(); }
      else if (ex === 'player' && chip.dataset.q) { state.q = chip.dataset.q; afterChange(); }
      else if (ex === 'season' && chip.dataset.season) { setVals(state.seasons, chip.dataset.season); afterChange(); }
      const plp = document.querySelector('.plp'); if (plp) window.scrollTo({ top: plp.offsetTop - 90, behavior: 'smooth' });
    }));
    updateArrows();
  }

  /* -------------------- vedettes (nations sur Coupe du Monde / clubs sur LDC) ------------ */
  // dispatcher : sur la vue Coupe du Monde -> nations vedettes ; sur la vue LDC -> clubs vedettes.
  function renderVedettes() { renderTopNations(); renderTopClubs(); }

  // Sur une page Coupe du Monde, le visiteur pense PAYS avant club : cartes drapeau
  // (drapeau + nom FR + nb de maillots) -> clic = selectClub(handle).
  function renderTopNations() {
    const host = $('#topNations'); if (!host) return;
    // n'apparait que sur la vue selections / Coupe du Monde (home par defaut), pas si club/recherche/favoris actifs.
    // On se base sur la SECTION (contexte persiste), pas sur collection : quand un club est selectionne dans
    // la section, clubs.size>0 masque deja la rangee (la grille montre alors l'equipe).
    const onSelections = state.section === 'selections' && !state.clubs.size && !state.favOnly && !state.q;
    if (!onSelections) { host.hidden = true; if (host._built) host.innerHTML = ''; host._built = false; return; }
    if (host._built) { host.hidden = false; return; }
    const nations = TEAMS
      .filter(t => t.league === 'nations' && teamCount(t) > 0)
      .sort((a, b) => teamCount(b) - teamCount(a))
      .slice(0, 8);
    if (nations.length < 2) { host.hidden = true; return; }
    host.hidden = false; host._built = true;
    // nation mise en avant : celle filtree si une seule l'est, sinon la 1ere (la plus fournie) par defaut
    const active = (state.clubs.size === 1) ? [...state.clubs][0] : (nations[0] ? nations[0].id : null);
    const cards = nations.map(t => {
      const n = teamCount(t);
      const isOn = active === t.id;
      return `<button class="tn__card${isOn ? ' is-on' : ''}" type="button" role="listitem" data-nation="${t.id}" aria-label="Voir les maillots ${teamFull(t)}" aria-pressed="${isOn}">
        <span class="tn__flag">${crestHTML(t, 'tn__crest')}</span>
        <span class="tn__body">
          <span class="tn__name">${teamFull(t)}</span>
          <span class="tn__count">${n} maillot${n > 1 ? 's' : ''}</span>
        </span>
      </button>`;
    }).join('');
    host.innerHTML = `<div class="tn__head">
        <span class="tn__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg></span>
        <div class="tn__headtx">
          <h2 class="tn__title">Les nations vedettes</h2>
          <p class="tn__sub">Choisis ton pays, le flocage à ton nom est offert.</p>
        </div>
      </div>
      <div class="tn__scroller">
        <button class="tn__nav tn__nav--prev" type="button" aria-label="Nations précédentes" hidden><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>
        <div class="tn__row" role="list">${cards}</div>
        <button class="tn__nav tn__nav--next" type="button" aria-label="Nations suivantes"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>
      </div>`;
    $$('.tn__card', host).forEach(c => c.addEventListener('click', () => selectClub(c.dataset.nation)));
    setupRowArrows($('.tn__scroller', host), $('.tn__row', host), $('.tn__nav--prev', host), $('.tn__nav--next', host));
  }

  // Sur la vue LDC, on met en avant les CLUBS : grandes cartes VERTICALES centrees
  // (grand logo + nom + nb de maillots + bouton "Voir") + pagination par points.
  function renderTopClubs() {
    const host = $('#topClubs'); if (!host) return;
    // n'apparait que sur la vue LDC, pas si un club/recherche/favoris est actif.
    // Base sur la SECTION (contexte persiste) : un club selectionne dans la section a clubs.size>0
    // -> rangee masquee, la grille montre l'equipe.
    const onLdc = state.section === 'ldc' && !state.clubs.size && !state.favOnly && !state.q;
    if (!onLdc) { host.hidden = true; if (host._built) host.innerHTML = ''; host._built = false; return; }
    if (host._built) { host.hidden = false; return; }
    const clubs = TEAMS
      // vrais clubs uniquement : on exclut les pseudo-equipes de collection (retro/selections/ldc/...) et les selections
      .filter(t => t.league !== 'nations' && !ICON_SVG[t.id] && teamCount(t) > 0)
      .sort((a, b) => teamCount(b) - teamCount(a))
      .slice(0, 8);
    if (clubs.length < 2) { host.hidden = true; return; }
    host.hidden = false; host._built = true;
    const cards = clubs.map(t => {
      const n = teamCount(t);
      return `<button class="cv__card" type="button" role="listitem" data-club="${t.id}" aria-label="Voir les maillots ${teamFull(t)}">
        <span class="cv__logo">${crestHTML(t, 'cv__crest')}</span>
        <span class="cv__name">${teamFull(t)}</span>
        <span class="cv__count">${n} maillot${n > 1 ? 's' : ''}</span>
        <span class="cv__btn">Voir <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>
      </button>`;
    }).join('');
    host.innerHTML = `<div class="cv__head">
        <div class="cv__headl">
          <span class="cv__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.2l5.4-.8Z"/></svg></span>
          <div class="cv__headtx">
            <h2 class="cv__title">Clubs vedettes</h2>
            <p class="cv__sub">Les plus populaires de la saison.</p>
          </div>
        </div>
        <button class="cv__all" type="button">Voir tous les clubs <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
      </div>
      <div class="cv__scroller">
        <button class="cv__nav cv__nav--prev" type="button" aria-label="Clubs précédents" hidden><svg viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg></button>
        <div class="cv__row" role="list">${cards}</div>
        <button class="cv__nav cv__nav--next" type="button" aria-label="Clubs suivants"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>
      </div>
      <div class="cv__dots" aria-hidden="true"></div>`;
    $$('.cv__card', host).forEach(c => c.addEventListener('click', () => selectClub(c.dataset.club)));
    // "Voir tous les clubs" : bascule sur la vue "Tous les maillots" et scrolle vers la grille
    $('.cv__all', host).addEventListener('click', () => {
      state.collection = null; state.section = 'all'; state.clubs.clear(); state.players.clear(); state.favOnly = false;
      afterChange();
      const g = $('#grid'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    setupRowArrows($('.cv__scroller', host), $('.cv__row', host), $('.cv__nav--prev', host), $('.cv__nav--next', host));
    setupVedettesDots(host);
  }

  // Fleches gauche/droite qui font slider une rangee horizontale, calquees sur le slider clubs
  // (.clubrow + .clubrow__nav) : scroll fluide par pas, fleches masquees aux extremites + fondus has-prev/has-next.
  function setupRowArrows(scroller, row, prev, next) {
    if (!scroller || !row) return;
    const STEP = () => Math.max(180, Math.round(row.clientWidth * 0.85));
    function updateArrows() {
      const max = row.scrollWidth - row.clientWidth - 1;
      const hasPrev = row.scrollLeft > 4;
      const hasNext = row.scrollWidth > row.clientWidth + 4 && row.scrollLeft < max;
      scroller.classList.toggle('has-prev', hasPrev);
      scroller.classList.toggle('has-next', hasNext);
      if (prev) prev.hidden = !hasPrev;
      if (next) next.hidden = !hasNext;
    }
    if (prev) prev.addEventListener('click', () => row.scrollBy({ left: -STEP(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => row.scrollBy({ left: STEP(), behavior: 'smooth' }));
    row.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', debounce(updateArrows, 120));
    updateArrows();
  }

  // points de pagination/carousel sous une rangee scrollable : reflete la position + clic = scroll
  function setupVedettesDots(host) {
    const row = $('.cv__row', host), dots = $('.cv__dots', host); if (!row || !dots) return;
    const cards = $$('.cv__card', row); if (cards.length < 2) { dots.hidden = true; return; }
    // une "page" = la largeur visible ; on derive le nombre de pages du contenu scrollable
    // (ceil + tolerance : des qu'il y a un debordement reel, on affiche au moins 2 points)
    function pageCount() { const w = Math.max(1, row.clientWidth); return Math.max(1, Math.ceil((row.scrollWidth - 4) / w)); }
    function build() {
      const pages = pageCount();
      if (pages <= 1) { dots.hidden = true; dots.innerHTML = ''; return; }
      dots.hidden = false;
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (let i = 0; i < pages; i++) {
          const d = el(`<button class="cv__dot" type="button" aria-label="Page ${i + 1}"></button>`);
          d.addEventListener('click', () => row.scrollTo({ left: i * row.clientWidth, behavior: 'smooth' }));
          dots.appendChild(d);
        }
      }
      sync();
    }
    function sync() {
      const all = $$('.cv__dot', dots); if (!all.length) return;
      const w = Math.max(1, row.clientWidth);
      // dernier point actif des qu'on atteint le bout (evite un index hors borne en fin de scroll)
      const atEnd = row.scrollLeft >= row.scrollWidth - w - 4;
      const idx = atEnd ? all.length - 1 : Math.min(all.length - 1, Math.round(row.scrollLeft / w));
      all.forEach((d, i) => d.classList.toggle('is-on', i === idx));
    }
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', debounce(build, 120));
    build();
  }

  /* -------------------- collections / decouverte / tendances -------- */
  function setCollection(id) {
    state.collection = (state.collection === id) ? null : id;
    if (!state.collection) state.section = null; // toggle off -> on quitte la section
    state.clubs.clear(); state.favOnly = false;
    afterChange();
    const plp = document.querySelector('.plp'); if (plp) window.scrollTo({ top: plp.offsetTop - 90, behavior: 'smooth' });
  }

  // barre d'onglets "collections" : icone + libelle + nombre de modeles + etat actif (souligne bleu).
  // desktop = 6 onglets en ligne ; mobile = 4 + bouton "Plus" qui revele le reste.
  const COLLTILES = [
    { id: null, label: 'Tous les maillots', icon: '<path d="M8 4 4 6.5 5.5 10 8 9v10h8V9l2.5 1L20 6.5 16 4l-2 2h-2z"/>' },
    { id: 'selections', label: 'Coupe du Monde 2026', icon: '<path d="M8 4h8v3.5a4 4 0 0 1-8 0V4Z"/><path d="M8 5.5H5v1a3 3 0 0 0 3 3"/><path d="M16 5.5h3v1a3 3 0 0 1-3 3"/><path d="M10.5 13h3l-.4 3.5h-2.2z"/><path d="M9.5 20.5h5"/>' },
    { id: 'ldc', label: 'LDC 2026', icon: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.4l1.2 2.5 2.7.3-2 1.8.6 2.7L12 15.4l-2.5 1.3.6-2.7-2-1.8 2.7-.3z"/>' },
    { id: 'retro', label: 'Rétro', icon: '<path d="M6 5 9 3l3 1.8L15 3l3 2-1 3.2-2-1V19H8V7.2l-2 1z"/>' },
    { id: 'flocages', label: 'Flocages', num: '10' },
    { id: 'limitees', collId: 'limitées', label: 'Éditions limitées', icon: '<path d="M6 3.5h12l3 5-9 12L3 8.5z"/><path d="M3 8.5h18M9 3.5 6 8.5l6 12M15 3.5l3 5-6 12"/>' }
  ];
  // Compte d'une tuile collection. La tuile "Tous les maillots" (cid null) prime sur _knownTotal (taille
  // du catalogue complet, connue d'avance cote Liquid/cache) -> nombre exact immediat, sans attendre
  // loadAll(). Les autres collections sont calculees sur le catalogue charge (selections/retro/ldc/flocages
  // sont quasi entierement dans le dump inline -> deja exactes ; toute correction se fait en une fois).
  function collCount(cid) { if (!cid) return Math.max(CATALOG.length, _knownTotal || 0); const c = COLL[cid]; return c ? CATALOG.filter(c.pred).length : 0; }
  function renderCollRow() {
    const host = $('#collRow'); if (!host) return;
    host.innerHTML = '';
    // onglet actif = la SECTION courante (contexte competition), pour rester surligne meme
    // quand un club est selectionne a l'interieur de cette section (collection videe).
    const sec = state.section;
    let vis = 0;
    COLLTILES.forEach((c) => {
      const cid = c.collId || c.id;
      // Masque les tuiles vides (0 produit) une fois le catalogue charge -> plus d'espace, pas de "0 modele".
      // Pendant loadAll (_loadingAll) une collection rare peut etre encore a 0 dans le dump inline : on
      // garde la tuile tant que ce n'est pas charge, on ne la masque qu'apres (quand 0 = vraiment vide).
      if (!_loadingAll && cid && collCount(cid) === 0) return;
      const active = cid ? sec === cid : ((!sec || sec === 'all') && !state.clubs.size && !state.favOnly);
      const icon = c.num ? `<span class="colltab__num">${c.num}</span>` : `<svg viewBox="0 0 24 24" class="colltab__svg">${c.icon}</svg>`;
      // COMPTEUR IMMEDIAT (plus de skeleton) : on affiche un NOMBRE des le 1er paint. "Tous les maillots"
      // est exact d'emblee (_knownTotal). Les collections calculees sur le dump inline (selections/retro/
      // ldc/flocages) sont quasi completes ; toute correction se fait en une fois en fin de loadAll.
      const cn = collCount(cid);
      const cntHTML = cn + (cn > 1 ? ' modèles' : ' modèle');
      // "extra" (cache derriere "Plus") = au-dela des 4 premieres tuiles REELLEMENT visibles (pas l'index brut).
      const isExtra = vis >= 4; vis++;
      const b = el(`<button class="colltab${isExtra ? ' colltab--extra' : ''} ${active ? 'is-on' : ''}" type="button" role="tab" aria-selected="${active}"><span class="colltab__ic">${icon}</span><span class="colltab__tx"><b class="colltab__label">${c.label}</b><span class="colltab__count">${cntHTML}</span></span></button>`);
      b.addEventListener('click', () => {
        if (!cid) { state.collection = null; state.section = 'all'; state.clubs.clear(); state.players.clear(); state.favOnly = false; }
        else { state.collection = cid; state.clubs.clear(); state.favOnly = false; }
        afterChange();
      });
      host.appendChild(b);
    });
    // Bouton "Plus" seulement s'il reste des tuiles au-dela des 4 premieres visibles.
    if (vis > 4) {
      const more = el(`<button class="colltab__more" type="button" aria-expanded="false"><svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg><span>Plus</span></button>`);
      more.addEventListener('click', () => { const on = host.classList.toggle('is-expanded'); more.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      host.appendChild(more);
    }
  }

  // Banniere hero "Nouveauté" : met en avant le club actif (sinon FC Barcelone par defaut)
  // Visuels de banniere dedies (image complete en fond) ; sinon visuel maillot detoure.
  const BANNER_BG = { barca: 'assets/hero-barca.png' };
  let _bannerKey = null;
  function renderHeroBanner() {
    const host = $('#heroBanner'); if (!host) return;
    // Coupe du Monde 2026 : banniere dediee (image fournie) en pleine largeur ; le reste de la page reste inchange
    const hero = host.closest('.hero');

    /* ===== "Tous les maillots" : banniere CLAIRE dediee (image-to-code tous_maillots.png) =====
       S'affiche sur la vue all (state.section==='all') sans club / recherche / favoris / collection.
       Meme mecanique que LDC : visuel (trophee + maillots + stade) en fond a droite, textes en HTML. */
    if (state.section === 'all' && !state.collection && !state.clubs.size && !state.favOnly && !state.q) {
      if (_bannerKey === 'tm') return; _bannerKey = 'tm';
      host.classList.remove('hb--photo', 'hb--ldc', 'hb--cdmp'); host.classList.add('hb--cdm', 'hb--tm');
      if (hero) hero.classList.add('hero--cdm');
      host.style.background = '';
      const imgT = (window.LATAKAN_IMG || {}).tmD || 'tousmaillots_bg.webp';
      const scrollGridT = () => { const g = $('#grid'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      host.innerHTML = `<div class="tmb">
        <div class="tmb__bg" aria-hidden="true"></div>
        <div class="tmb__beam" aria-hidden="true"></div>
        <img class="tmb__visual" src="${imgT}" alt="Trophée argenté et cinq maillots premium des plus grands clubs dans un stade illuminé" loading="eager" decoding="async">
        <div class="tmb__content">
          <span class="tmb__eyebrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>Livraison en 14 jours • Retours 30 jours</span>
          <h2 class="tmb__title"><span class="tmb__l1">Tous les</span><span class="tmb__l2">Maillots</span></h2>
          <p class="tmb__sub"><span>Ton club. Ton pays. Ton style.</span><span class="tmb__sub2" data-catcount>${catalogCountLabel()} maillots disponibles</span></p>
          <ul class="tmb__feats">
            <li><span class="tmb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg></span><div><b>Qualité premium</b><span>Finitions soignées</span></div></li>
            <li><span class="tmb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg></span><div><b>Expédition sous 14 jours</b><span>Livraison dès 60€</span></div></li>
            <li><span class="tmb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5M18 4v3h-3M20 12a8 8 0 0 1-14 5M6 20v-3h3"/></svg></span><div><b>Retours gratuits</b><span>Sous 30 jours</span></div></li>
            <li><span class="tmb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4 4 6l1.6 3L8 8v11h8V8l2.4 1L20 6l-4-2-2 2h-4z"/></svg></span><div><b>Flocage personnalisé</b><span>Nom, numéro, texte</span></div></li>
          </ul>
          <div class="tmb__cta">
            <button class="tmb__btn" type="button"><span>Découvrir la collection</span></button>
            <p class="tmb__proof"><span class="tmb__pstars" aria-hidden="true">★★★★<span class="tmb__half">★</span></span><b>4,8/5</b><span class="tmb__proofcount">sur 482 avis</span></p>
          </div>
        </div>
      </div>`;
      $('.tmb__btn', host).addEventListener('click', scrollGridT);
      return;
    }
    host.classList.remove('hb--tm');

    if (state.collection === 'selections' || state.collection === 'ldc') {
      const isLdc = state.collection === 'ldc';
      const _bk = isLdc ? 'ldc' : 'cdm';
      if (_bannerKey === _bk) return; _bannerKey = _bk;
      host.classList.remove('hb--photo'); host.classList.add('hb--cdm');
      host.classList.toggle('hb--ldc', isLdc);
      host.classList.toggle('hb--cdmp', !isLdc);
      if (hero) hero.classList.add('hero--cdm');
      host.style.background = '';
      const _L = window.LATAKAN_IMG || {};
      const scrollGrid = () => { const g = $('#grid'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); };

      /* ===== Ligue des Champions : banniere CLAIRE dediee (image-to-code, fond blanc + ambiance verte) ===== */
      if (isLdc) {
        const imgD = _L.ldcD || 'ldc_bg.webp';
        host.innerHTML = `<div class="ldcb">
          <div class="ldcb__bg" aria-hidden="true"></div>
          <div class="ldcb__beam" aria-hidden="true"></div>
          <div class="ldcb__stars" aria-hidden="true">
            <svg viewBox="0 0 24 24" class="ldcb__star ldcb__star--a"><path d="M12 2l2.2 6.4L21 9.2l-5 4.3L17.6 21 12 17.1 6.4 21 8 13.5 3 9.2l6.8-.8z"/></svg>
            <svg viewBox="0 0 24 24" class="ldcb__star ldcb__star--b"><path d="M12 2l2.2 6.4L21 9.2l-5 4.3L17.6 21 12 17.1 6.4 21 8 13.5 3 9.2l6.8-.8z"/></svg>
            <svg viewBox="0 0 24 24" class="ldcb__star ldcb__star--c"><path d="M12 2l2.2 6.4L21 9.2l-5 4.3L17.6 21 12 17.1 6.4 21 8 13.5 3 9.2l6.8-.8z"/></svg>
          </div>
          <img class="ldcb__visual" src="${imgD}" alt="Trophée argenté de la Ligue des Champions et trois maillots premium blanc et vert dans un stade illuminé" loading="eager" decoding="async">
          <div class="ldcb__content">
            <span class="ldcb__eyebrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.2 6.4L21 9.2l-5 4.3L17.6 21 12 17.1 6.4 21 8 13.5 3 9.2l6.8-.8z"/></svg>Nuit européenne, saison 2025/26</span>
            <h2 class="ldcb__title"><span class="ldcb__ldc">Ligue des<br>Champions</span> <span class="ldcb__year">2026</span></h2>
            <p class="ldcb__tagline">Les maillots des plus grands clubs d'Europe, prêts à soulever le trophée aux grandes oreilles.</p>
            <div class="ldcb__cta">
              <button class="ldcb__btn" type="button"><span>Découvrir la collection</span></button>
              <p class="ldcb__proof"><span class="ldcb__pstars" aria-hidden="true">★★★★<span class="ldcb__half">★</span></span><b>4,8/5</b><span class="ldcb__proofcount">sur 482 avis</span></p>
            </div>
            <ul class="ldcb__feats">
              <li><span class="ldcb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4 4 6l1.6 3L8 8v11h8V8l2.4 1L20 6l-4-2-2 2h-4z"/></svg></span><div><b>Maillots premium</b><span>Finitions soignées</span></div></li>
              <li><span class="ldcb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11Z"/><circle cx="12" cy="10" r="2.6"/></svg></span><div><b>Flocage offert</b><span>Nom, numéro, texte</span></div></li>
              <li><span class="ldcb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg></span><div><b>Expédition sous 14 jours</b><span>Dès 60€ d'achat</span></div></li>
              <li><span class="ldcb__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5M18 4v3h-3M20 12a8 8 0 0 1-14 5M6 20v-3h3"/></svg></span><div><b>Retours gratuits</b><span>Sous 30 jours</span></div></li>
            </ul>
          </div>
        </div>`;
        $('.ldcb__btn', host).addEventListener('click', scrollGrid);
        return;
      }

      /* ===== Coupe du Monde 2026 : banniere CLAIRE premium (image-to-code cdm_bg_premium.png) =====
         Vue PAR DEFAUT de la home. Meme langage que "Tous les maillots" / LDC : fond stade blanc/brumeux,
         vert #4FB477 en ACCENT, visuel (trophee dore + 3 maillots) a droite, textes + boutons en HTML.
         Classes .cdmp__* dediees (independantes des anciennes .cdm* sombres, supprimees). */
      const imgC = _L.cdmpD || _L.cdmD || 'cdm_premium_bg.webp';
      const imgCm = _L.cdmM || imgC;
      // ZONE TABLETTE / FOLD (600-1100px, ex. Zenbook Fold ~853px) : le visuel paysage (trophee + 3 maillots
      // colle a droite) est ecrase dans 50% de largeur et s'incruste mal. On sert alors le visuel PORTRAIT
      // dedie (imgCm), bien plus propre a ce format, via <source media>. Au-dela de 1100px, le paysage reprend.
      // L'<img class="cdmp__visual"> reste le fallback : tous les styles .cdmp__visual continuent de s'appliquer.
      host.innerHTML = `<div class="cdmp">
        <div class="cdmp__bg" aria-hidden="true"></div>
        <div class="cdmp__beam" aria-hidden="true"></div>
        <picture class="cdmp__pic">
          <source media="(min-width:600px) and (max-width:1100px)" srcset="${imgCm}">
          <img class="cdmp__visual" src="${imgC}" alt="Trophée doré de la Coupe du Monde et trois maillots premium verts et blancs dans un stade illuminé" loading="eager" decoding="async">
        </picture>
        <img class="cdmp__visual cdmp__visual--m" src="${imgCm}" alt="" aria-hidden="true" loading="eager" decoding="async">
        <div class="cdmp__scrim cdmp__scrim--m" aria-hidden="true"></div>
        <button class="cdmp__float" type="button"><span>Découvrir la collection</span></button>
        <div class="cdmp__content">
          <span class="cdmp__eyebrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>Livraison en 14 jours • Retours 30 jours</span>
          <h2 class="cdmp__title"><span class="cdmp__l1">Coupe du monde</span><span class="cdmp__l2">2026<sup>™</sup></span></h2>
          <p class="cdmp__sub"><span>Ton club. Ton pays. Ton style.</span><span class="cdmp__sub2" data-catcount>${catalogCountLabel()} maillots disponibles</span></p>
          <ul class="cdmp__feats">
            <li><span class="cdmp__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg></span><div><b>Qualité premium</b><span>Finitions soignées</span></div></li>
            <li><span class="cdmp__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg></span><div><b>Expédition sous 14 jours</b><span>Livraison dès 60€</span></div></li>
            <li><span class="cdmp__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5M18 4v3h-3M20 12a8 8 0 0 1-14 5M6 20v-3h3"/></svg></span><div><b>Retours gratuits</b><span>Sous 30 jours</span></div></li>
            <li><span class="cdmp__fic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4 4 6l1.6 3L8 8v11h8V8l2.4 1L20 6l-4-2-2 2h-4z"/></svg></span><div><b>Flocage personnalisé</b><span>Nom, numéro, texte</span></div></li>
          </ul>
          <div class="cdmp__cta">
            <button class="cdmp__btn" type="button"><span>Découvrir la collection</span></button>
            <p class="cdmp__proof"><span class="cdmp__pstars" aria-hidden="true">★★★★<span class="cdmp__half">★</span></span><b>4,8/5</b><span class="cdmp__proofcount">sur 482 avis</span></p>
          </div>
        </div>
      </div>`;
      $$('.cdmp__btn, .cdmp__float', host).forEach(_g => _g.addEventListener('click', scrollGrid));
      return;
    }
    host.classList.remove('hb--cdm', 'hb--ldc', 'hb--cdmp');
    if (hero) hero.classList.remove('hero--cdm');
    const id = (state.clubs.size === 1 && TEAM[[...state.clubs][0]]) ? [...state.clubs][0] : (TEAMS[0] ? TEAMS[0].id : 'barca');
    if (_bannerKey === 'team:' + id) return; _bannerKey = 'team:' + id;
    const t = TEAM[id] || TEAMS[0]; if (!t) { host.classList.remove('hb--cdm'); host.innerHTML = ''; return; }
    host.classList.remove('hb--photo');
    const mix = (hex, tgt, a) => { const c = hexRgb(hex), y = hexRgb(tgt), m = k => Math.round(c[k] + (y[k] - c[k]) * a); return `rgb(${m('r')},${m('g')},${m('b')})`; };
    const sat = c => { const { r, g, b } = hexRgb(c); const mx = Math.max(r, g, b), mn = Math.min(r, g, b); return mx ? (mx - mn) / mx : 0; };
    const colorful = [t.c1, t.c2].filter(c => sat(c) > 0.22 && lum(c) > 0.04 && lum(c) < 0.9);
    let drk, mdc, lgt, glowC;
    if (colorful.length) {
      const acc = colorful[0], darkest = [t.c1, t.c2].slice().sort((x, y) => lum(x) - lum(y))[0];
      const baseC = (lum(darkest) < 0.30 && lum(darkest) < lum(acc)) ? darkest : acc;
      drk = mix(baseC, '#090C16', 0.62); mdc = mix(acc, '#090C16', 0.10); lgt = acc; glowC = acc;
    } else {
      drk = '#141C30'; mdc = '#3F5C99'; lgt = '#AEBEE0'; glowC = '#8AA0D6';
    }
    host.style.background = `linear-gradient(101deg, ${drk} 0%, ${drk} 46%, ${mdc} 76%, ${lgt} 100%)`;
    const ar = hexRgb(glowC);
    const media = crestHTML(t, 'hb__crest');
    host.innerHTML = `<div class="hb__glow" aria-hidden="true"></div>
      <div class="hb__txt"><span class="hb__eyebrow"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l1.7 5.6L19.4 9l-5.7 1.4L12 16l-1.7-5.6L4.6 9l5.7-1.4z"/></svg>Votre sélection</span><h2 class="hb__name">${teamFull(t)}</h2><p class="hb__edition">${heroTagline(t)}</p>
      <button class="hb__cta" type="button"><span>Découvrir la collection</span></button></div>
      ${media}`;
    $('.hb__glow', host).style.background = `radial-gradient(62% 96% at 70% 50%, rgba(${ar.r},${ar.g},${ar.b},.28), transparent 72%)`;
    // "Decouvrir la collection" : le club est deja selectionne (le hero ne s'affiche que dans ce cas),
    // donc le bouton DOIT amener l'utilisateur a la grille de produits juste en dessous (scroll doux).
    $('.hb__cta', host).addEventListener('click', () => { const g = $('#grid'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  /* ----------------------------- sidebar ---------------------------- */
  function facet(key, title, icon, bodyEl, collapsed) {
    const f = el(`<div class="facet ${collapsed ? 'is-collapsed' : ''}" data-facet="${key}">
      <button class="facet__h">${icon}${title}<svg class="chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button>
      <div class="facet__body"></div></div>`);
    $('.facet__body', f).appendChild(bodyEl);
    $('.facet__h', f).addEventListener('click', () => f.classList.toggle('is-collapsed'));
    return f;
  }
  function optRow(set, value, label, count) {
    const o = el(`<label class="opt"><input type="checkbox" ${set.has(value) ? 'checked' : ''}><span class="opt__box"><svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg></span><span class="opt__name">${label}</span>${count != null ? `<span class="opt__n">${count}</span>` : ''}</label>`);
    const inp = $('input', o);
    inp.dataset.set = ''; inp._set = set; inp._value = value;
    inp.addEventListener('change', () => { if (inp.checked) set.add(value); else set.delete(value); afterChange(); });
    return o;
  }

  function buildSidebar() {
    const sb = $('#sideBody'); sb.innerHTML = '';
    // Saison
    const seasonBody = el('<div></div>');
    SEASONS.forEach(s => seasonBody.appendChild(optRow(state.seasons, s, s, CB_SEASON[s])));
    // Type
    const typeBody = el('<div></div>');
    availableTypes().forEach(t => typeBody.appendChild(optRow(state.types, t, t, CB_TYPE[t])));
    // Taille
    const sizeBody = el('<div class="chiprow"></div>');
    // Tailles reelles du catalogue (adultes S..XXL puis numeriques enfant 16..28). Re-evalue a chaque buildSidebar
    // (init + fin de loadAll) -> reflete toutes les tailles une fois le catalogue complet charge.
    availableSizes().forEach(s => { const b = el(`<button class="szchip ${state.sizes.has(s) ? 'is-on' : ''}">${s}</button>`); b.addEventListener('click', () => { b.classList.toggle('is-on'); if (state.sizes.has(s)) state.sizes.delete(s); else state.sizes.add(s); afterChange(); }); sizeBody.appendChild(b); });
    // Prix
    const priceBody = el('<div></div>');
    const pr = el('<div class="price-row"><input type="number" min="0" placeholder="Min" id="prMin"><span>a</span><input type="number" min="0" placeholder="Max" id="prMax"></div>');
    priceBody.appendChild(pr);
    const prApply = el('<button class="facet__more">Appliquer</button>');
    prApply.addEventListener('click', () => { let mn = parseFloat($('#prMin', pr).value); let mx = parseFloat($('#prMax', pr).value); if (isNaN(mn)) mn = 0; if (isNaN(mx)) mx = Infinity; if (mn > mx) [mn, mx] = [mx, mn]; state.price = (mn > 0 || mx < Infinity) ? [mn, mx] : null; afterChange(); });
    priceBody.appendChild(prApply);

    const I = (p) => `<svg class="fi" viewBox="0 0 24 24">${p}</svg>`;
    // Ordre fidele a la maquette : Categorie, Saison en tete. Le club est pilote
    // par la rangee de chips au-dessus -> pas de facette Club ni Joueur dans la sidebar.
    sb.appendChild(facet('type', 'Catégorie', I('<path d="M4 7h16M4 12h16M4 17h10"/>'), typeBody, false));
    sb.appendChild(facet('saison', 'Saison', I('<circle cx="12" cy="13" r="8"/><path d="M12 9v4l3 2M9 2h6"/>'), seasonBody, false));
    sb.appendChild(facet('taille', 'Taille', I('<path d="M3 8h18v8H3zM7 8v4M11 8v6M15 8v4"/>'), sizeBody, true));
    sb.appendChild(facet('prix', 'Prix', I('<circle cx="12" cy="12" r="9"/><path d="M14 9.5C13.5 8.5 8 8 8 12s5.5 3.5 5 4.5"/>'), priceBody, true));
  }

  // synchronise l'etat des controles avec state (sans rebuild)
  function syncUI() {
    $$('#sideBody .opt input').forEach(inp => { inp.checked = inp._set.has(inp._value); });
    $$('#clubRow .cchip').forEach(ch => ch.classList.toggle('is-on', state.clubs.has(ch.dataset.club)));
    $$('#sideBody .fchip').forEach(ch => ch.classList.toggle('is-on', state.clubs.has(ch.dataset.club)));
    $$('#sideBody .szchip').forEach(b => b.classList.toggle('is-on', state.sizes.has(b.textContent.trim())));
    $$('.coll').forEach(c => { const on = state.collection === c.dataset.coll; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
    $$('.dtile').forEach(d => d.classList.toggle('is-on', state.collection === d.dataset.coll));
    // lien de navigation actif : pilote par la SECTION (contexte persiste), pour rester surligne
    // meme quand un club est selectionne a l'interieur de la section (collection videe).
    const _nav = state.section;
    const navFor = _nav === 'retro' ? 'retro'
      : _nav === 'flocages' ? 'players'
      : _nav === 'selections' ? 'nations'
      : _nav === 'ldc' ? 'ldc'
      : 'all';  // vue par defaut (aucune competition) -> "Tous les maillots" actif
    $$('.nav__link').forEach(a => a.classList.toggle('is-active', a.dataset.nav === navFor));
    // vue (grille/liste) : reappliquer l'etat comme source de verite
    $$('.vtoggle__b').forEach(b => { const on = b.dataset.view === state.view; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    body.dataset.view = state.view;
    recountFacets();
  }

  /* ----------------------------- tri / vue -------------------------- */
  $('#sortBtn').addEventListener('click', () => openMenu($('#sortBtn'), SORTS, state.sort, v => { state.sort = v; $('#sortLabel').textContent = SORTS.find(s => s.id === v).label; state.page = 1; render(); }));
  $('#perPageBtn').addEventListener('click', () => openMenu($('#perPageBtn'), [{ id: 12, label: '12' }, { id: 24, label: '24' }, { id: 48, label: '48' }], state.pageSize, v => { state.pageSize = v; $('#perPageBtn').firstChild.textContent = v + ' '; state.page = 1; render(); }));
  $$('.vtoggle__b').forEach(b => b.addEventListener('click', () => { state.view = b.dataset.view; syncUI(); render(); }));

  let menuEl = null, menuAnchor = null;
  function closeMenu() { if (menuEl) { menuEl.remove(); menuEl = null; menuAnchor = null; document.removeEventListener('click', onDocMenu, true); } }
  function onDocMenu(e) { if (menuEl && !menuEl.contains(e.target) && !(menuAnchor && menuAnchor.contains(e.target))) closeMenu(); }
  function openMenu(anchor, items, current, onPick) {
    // re-clic sur l'ancre d'un menu deja ouvert => fermer (toggle)
    if (menuEl && menuAnchor === anchor) { closeMenu(); return; }
    closeMenu(); const m = el('<div class="menu"></div>');
    items.forEach(it => { const b = el(`<button class="menu__item ${it.id === current ? 'is-on' : ''}">${it.label}</button>`); b.addEventListener('click', () => { closeMenu(); onPick(it.id); }); m.appendChild(b); });
    document.body.appendChild(m); const r = anchor.getBoundingClientRect();
    let left = Math.min(r.left + scrollX, scrollX + document.documentElement.clientWidth - m.offsetWidth - 12);
    m.style.top = (r.bottom + scrollY + 8) + 'px'; m.style.left = Math.max(scrollX + 12, left) + 'px';
    menuEl = m; menuAnchor = anchor; setTimeout(() => document.addEventListener('click', onDocMenu, true), 0);
  }

  /* ----------------------------- recherche -------------------------- */
  const qInput = $('#q'), suggest = $('#suggest');
  function buildSuggestions(qRaw) {
    const q = norm(qRaw); suggest.innerHTML = '';
    if (!q) { suggest.hidden = true; qInput.setAttribute('aria-expanded', 'false'); return; }
    const hits = SEARCH.map(s => { const cands = s.aliases || [s.label]; let best = -1; for (const c of cands) { const i = norm(c).indexOf(q); if (i !== -1 && (best === -1 || i < best)) best = i; } return { s, i: best }; }).filter(o => o.i !== -1).sort((a, b) => a.i - b.i || a.s.label.length - b.s.label.length);
    if (!hits.length) { suggest.innerHTML = `<p class="sug-empty">Aucun résultat pour " ${qRaw} ".</p>`; suggest.hidden = false; qInput.setAttribute('aria-expanded', 'true'); return; }
    const order = ['Club', 'Sélection', 'Joueur', 'Collection'], groups = {}; hits.forEach(({ s }) => (groups[s.kind] = groups[s.kind] || []).push(s));
    const hl = l => { const i = norm(l).indexOf(q); return i < 0 ? l : l.slice(0, i) + '<b>' + l.slice(i, i + q.length) + '</b>' + l.slice(i + q.length); };
    qInput.setAttribute('aria-expanded', 'true');
    order.forEach(kind => { const arr = (groups[kind] || []).slice(0, 6); if (!arr.length) return; const g = el(`<div class="sug-group"><p class="sug-group__label">${kind}s</p></div>`); arr.forEach(s => { const ent = s.team ? TEAM[s.team] : null; const vis = ent ? crestHTML(ent) : '<span class="crest"><span class="mono" style="background:var(--blue-soft);color:var(--blue)">#</span></span>'; const b = el(`<button class="sug">${vis}<span class="sug__txt"><span class="sug__label">${hl(s.label)}</span><span class="sug__sub">${s.sub}</span></span><span class="sug__kind">${s.kind}</span></button>`); b.addEventListener('click', () => { qInput.value = ''; state.q = ''; s.apply(); }); g.appendChild(b); }); suggest.appendChild(g); });
    suggest.hidden = false;
  }
  function closeSuggest() { suggest.hidden = true; qInput.setAttribute('aria-expanded', 'false'); }
  qInput.addEventListener('input', debounce(() => buildSuggestions(qInput.value)));
  qInput.addEventListener('keydown', e => { if (e.key === 'Enter') { closeSuggest(); const v = qInput.value.trim(); [state.clubs, state.seasons, state.types, state.players, state.sizes].forEach(s => s.clear()); state.collection = null; state.section = null; state.favOnly = false; state.q = v; afterChange(); } if (e.key === 'Escape') closeSuggest(); });
  document.addEventListener('click', e => { if (!$('.hdr__search').contains(e.target)) closeSuggest(); });

  /* ----------------------------- vue rapide ------------------------- */
  const qv = $('#qv'); let qvP = null, qvSize = 'M';
  // FLOCAGE = nom (texte du haut) + numero + texte du bas uniquement. Le choix d'ecusson a ete retire :
  // plus de champ badge dans l'etat, plus de property "Écusson" envoyee au panier.
  const FLOC_PRICE = 0; const floc = { on: false, name: '', num: '', bottom: '' };

  // theme media adaptatif (teinte produit) + galerie de vues (recadrages du visuel reel)
  const mixHex = (hex, tgt, a) => { const c = hexRgb(hex), y = hexRgb(tgt), m = k => Math.round(c[k] + (y[k] - c[k]) * a).toString(16).padStart(2, '0'); return '#' + m('r') + m('g') + m('b'); };
  const satOf = (c) => { const { r, g, b } = hexRgb(c); const mx = Math.max(r, g, b), mn = Math.min(r, g, b); return mx ? (mx - mn) / mx : 0; };
  const accentOf = (t) => { const cands = [t.c1, t.c2].filter(c => satOf(c) > 0.18 && lum(c) > 0.05 && lum(c) < 0.92); return cands[0] || (lum(t.c1) < lum(t.c2) ? t.c2 : t.c1) || '#4FB477'; };
  const GALLERY_VIEWS = [
    { z: 1,   ox: 50, oy: 50 }, // vue d'ensemble
    { z: 2.1, ox: 50, oy: 15 }, // col / haut
    { z: 2.2, ox: 50, oy: 46 }, // ecusson / centre
    { z: 2.1, ox: 30, oy: 72 }, // motif bas
    { z: 2.0, ox: 72, oy: 32 }  // manche / cote
  ];
  let gViews = [], gIdx = 0;
  function setView(i) {
    if (!gViews.length) return;
    gIdx = (i + gViews.length) % gViews.length; const v = gViews[gIdx], main = $('#qvMain');
    if (main) {
      if (v.real) {
        const img = main.querySelector('img');
        // echange direct de la source (pas de fondu opacity : la navigation rapide fleches/swipe
        // pouvait laisser une transition d'opacite coincee -> image invisible). L'echange est instantane
        // et fiable ; le slide reste fluide via le scroll/zoom existant.
        if (img && img.getAttribute('src') !== v.src) img.src = v.src;
      }
      else { main.style.setProperty('--z', v.z); main.style.setProperty('--ox', v.ox + '%'); main.style.setProperty('--oy', v.oy + '%'); }
    }
    $$('#qvThumbs .qvg__thumb').forEach((t, k) => { const on = k === gIdx; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    const c = $('#qvCount'); if (c) c.textContent = (gIdx + 1) + '/' + gViews.length;
  }
  function renderGallery(p) {
    const main = $('#qvMain'), thumbs = $('#qvThumbs'), count = $('#qvCount'), nav = $('#qvNav');
    thumbs.innerHTML = ''; main.innerHTML = ''; gIdx = 0; main.style.backgroundImage = '';
    // ANTI-FOUC : on affiche IMMEDIATEMENT l'image featured deja connue (data inline / carte cliquee)
    // comme image principale + 1re vignette. lazyGallery viendra completer/remplacer en fond.
    // le skeleton (is-loading) reste tant que la galerie complete n'est pas chargee.
    main.classList.toggle('is-loading', !p._galLoaded);
    // photo produit en contain -> le fond bg_product.png (CSS sur .qvg__main) apparait autour (raccord pelouse)
    const list = (p.images && p.images.length) ? p.images.slice() : (imgFor(p) ? [imgFor(p)] : []);
    if (!list.length) { main.classList.remove('qvg__main--fit', 'is-loading'); main.innerHTML = jersey(p); gViews = []; thumbs.hidden = true; count.hidden = true; nav.hidden = true; return; }
    main.classList.add('qvg__main--fit');
    gViews = list.map(src => ({ real: true, src }));
    main.innerHTML = `<img class="shot" src="${list[0]}" alt="${p.title}" decoding="async">`;
    // skeleton retire des que l'image principale est peinte (ou si elle est deja en cache)
    const _shot = main.querySelector('img.shot');
    if (_shot) { const _done = () => main.classList.remove('is-loading'); if (_shot.complete) _done(); else { _shot.addEventListener('load', _done, { once: true }); _shot.addEventListener('error', _done, { once: true }); } }
    if (list.length > 1) {
      list.forEach((src, i) => {
        const th = el(`<button class="qvg__thumb${i === 0 ? ' is-on' : ''}" type="button" role="tab" aria-selected="${i === 0 ? 'true' : 'false'}" aria-label="Photo ${i + 1}" style="background-image:url('${src}')"></button>`);
        th.addEventListener('click', () => setView(i));
        thumbs.appendChild(th);
      });
      thumbs.hidden = false; count.hidden = false; nav.hidden = false;
    } else { thumbs.hidden = true; count.hidden = true; nav.hidden = true; }
    setView(0);
  }
  // (Coeur wishlist retire de la vue rapide : plus de #qvFav ni de syncQvFav. Le coeur des CARTES de
  // la grille reste la wishlist active ; toggleFav() est toujours utilise par celles-ci.)
  let _qvExtras = false;
  function setupQVExtras() {
    if (_qvExtras) return; _qvExtras = true;
    const prev = $('#qvPrev'), next = $('#qvNext'), guide = $('#qvGuide');
    if (prev) prev.addEventListener('click', () => setView(gIdx - 1));
    if (next) next.addEventListener('click', () => setView(gIdx + 1));
    if (guide) guide.addEventListener('click', () => { window.location.href = '/pages/guide-des-tailles'; });
    // SWIPE TACTILE (mobile) sur la scene principale : glisser a gauche = photo suivante, a droite = precedente.
    // touch-action:pan-y autorise le scroll vertical de la page et ne capte QUE le geste horizontal.
    // Seuil ~40px ET dominance horizontale (|dx| > |dy|) -> un scroll vertical ne change jamais d'image.
    const stage = $('#qvMain');
    if (stage) {
      stage.style.touchAction = 'pan-y';
      let sx = 0, sy = 0, swiping = false;
      stage.addEventListener('touchstart', (e) => {
        if (gViews.length < 2 || !e.touches || e.touches.length !== 1) { swiping = false; return; }
        swiping = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (!swiping) return; swiping = false;
        const t0 = (e.changedTouches && e.changedTouches[0]); if (!t0) return;
        const dx = t0.clientX - sx, dy = t0.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { setView(dx < 0 ? gIdx + 1 : gIdx - 1); }
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { swiping = false; }, { passive: true });
    }
    // lien "Voir les N avis" : navigue vers la page avis (/pages/avis-clients?product=<handle>).
    // href construit dans reviewsHTML a chaque openQV -> on laisse le clic suivre le lien (pas de preventDefault).
  }

  // galerie chargee a la demande (la data inline ne porte que la vignette -> F5 rapide)
  function lazyGallery(p) {
    if (!p || !p.handle || p._galLoaded) return;
    p._galLoaded = true;
    // skeleton retire dans tous les cas en fin de fetch (succes/echec/pas d'images supplementaires)
    const _clearSkeleton = function () { const m = $('#qvMain'); if (m && qvP === p) m.classList.remove('is-loading'); };
    fetch('/products/' + p.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.images || d.images.length < 2) { _clearSkeleton(); return; }
        p.images = d.images.map(function (u) { u = (u.indexOf('//') === 0) ? ('https:' + u) : u; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=800'; });
        if (qvP === p && !qv.hidden) renderGallery(p); else _clearSkeleton();
      })
      .catch(function () { _clearSkeleton(); });
  }
  /* ----------------------------- avis (vue rapide) ------------------ */
  // Bloc d'avis clients de la vue rapide. UI VISIBLE uniquement (aucun schema.org / aggregateRating
  // injecte ici, par prudence juridique). Brand-safe : aucun terme sensible. Pas de tiret cadratin.
  // AUCUNE donnee d'avis fabriquee : la note et le compteur viennent des metachamps Shopify
  // (custom.review_rating / custom.review_count via p.rating / p.reviews). La repartition et les
  // temoignages reels sont charges a la demande depuis /products/<handle>?view=reviewsjson.
  function escHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // rangee d'etoiles or pleines (n sur 5) ; entier borne 0..5
  function revStars(n) {
    n = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    return '<span class="qvrev__stars" aria-hidden="true">' + '★'.repeat(n) + '☆'.repeat(5 - n) + '</span>';
  }
  function reviewsHTML(p) {
    const reviews = (p.reviews != null ? p.reviews : 0) | 0;
    const handle = encodeURIComponent(p.handle || '');
    const reviewsUrl = `/pages/avis-clients?product=${handle}`;
    if (reviews <= 0) {
      // etat vide premium : icone bulle-de-chat-avec-etoile, CTA "Donner mon avis", gage d'avis verifies.
      // aucune note bidon ; le CTA ouvre le formulaire d'avis existant (page avis, ancre #ecrire-un-avis).
      return `<div class="rvempty">
          <span class="rvempty__ic">
            <svg class="rvempty__spark" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3v4M3 5h4"/><path d="M11 5l1 2 2 1-2 1-1 2-1-2-2-1 2-1z"/></svg>
            <svg class="rvempty__bubble" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v9A1.5 1.5 0 0 1 18.5 16H9l-4 3.5V16H5.5A1.5 1.5 0 0 1 4 14.5z"/><path d="M12 7.4l1.15 2.33 2.57.37-1.86 1.81.44 2.56L12 13.26l-2.3 1.21.44-2.56-1.86-1.81 2.57-.37z" fill="currentColor" stroke="none"/></svg>
          </span>
          <p class="rvempty__title">Pas encore d'avis.<br>Sois le premier !</p>
          <p class="rvempty__sub">Ton avis aide la communauté à faire le bon choix.</p>
          <a class="rvempty__cta" href="${reviewsUrl}#ecrire-un-avis">
            <svg class="rvempty__pen" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4l10-10-4-4L4 16v4Z"/><path d="M13.5 6.5l4 4"/></svg>
            <span>Donner mon avis</span>
            <svg class="rvempty__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
          </a>
          <span class="rvempty__sep" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg></span>
          <p class="rvempty__foot"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Avis vérifiés et authentiques</p>
        </div>`;
    }
    const rating = (p.rating != null ? p.rating : 0);
    const ratingTxt = String(rating).replace('.', ',');
    const sN = revStars(rating);
    // Resume immediat (note + compteur) sans temoignage invente. Le reste (repartition +
    // temoignages reels) est injecte par fillReviews() apres le fetch reviewsjson.
    return `<div class="qvrev__grid">
        <div class="qvrev__sum">
          <div class="qvrev__big"><b>${ratingTxt}</b><span class="qvrev__out">/5</span></div>
          ${sN}
          <p class="qvrev__count">${reviews} avis</p>
        </div>
        <div class="qvrev__dist" data-rev-dist role="img" aria-label="Répartition des notes sur 5 étoiles"></div>
        <div class="qvrev__quotes" data-rev-quotes></div>
      </div>
      <a class="qvrev__all" href="${reviewsUrl}" aria-label="Voir les ${reviews} avis clients">Voir les ${reviews} avis<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></a>`;
  }
  // LAZY fetch des avis reels (repartition + 1 a 2 temoignages) a l'ouverture de la QV.
  // Ne fabrique rien : si le fetch echoue ou ne renvoie rien, on garde note + compteur + lien seuls.
  function lazyReviews(p) {
    if (!p || !p.handle || !((p.reviews | 0) > 0) || p._revLoaded) return;
    p._revLoaded = true;
    fetch('/products/' + encodeURIComponent(p.handle) + '?view=reviewsjson')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || qvP !== p || qv.hidden) return;
        fillReviews(d);
      })
      .catch(function () { /* silencieux : on garde le resume sans temoignage */ });
  }
  // Remplit la repartition et jusqu'a 2 temoignages REELS depuis la vue reviewsjson.
  function fillReviews(d) {
    const root = $('#qvReviews'); if (!root) return;
    const distEl = root.querySelector('[data-rev-dist]');
    const qEl = root.querySelector('[data-rev-quotes]');
    const count = (d && d.count) | 0;
    if (distEl && d && d.distribution && count > 0) {
      const order = [5, 4, 3, 2, 1];
      distEl.innerHTML = order.map(function (st) {
        const n = (d.distribution[st] | 0);
        const pct = Math.round((n / count) * 100);
        return `<div class="qvrev__drow"><span class="qvrev__dstar">${st}<span class="qvrev__dico" aria-hidden="true">★</span></span><span class="qvrev__track"><span class="qvrev__fill" style="width:${pct}%"></span></span><span class="qvrev__pct">${pct}%</span></div>`;
      }).join('');
    }
    if (qEl && d && Array.isArray(d.reviews) && d.reviews.length) {
      qEl.innerHTML = d.reviews.slice(0, 2).map(function (rv) {
        const who = escHTML(rv.author || '');
        const txt = escHTML(rv.body || rv.title || '');
        const head = revStars(rv.rating);
        return `<figure class="qvrev__quote"><div class="qvrev__qhead">${head}<figcaption class="qvrev__who">${who}</figcaption></div><blockquote class="qvrev__qtxt">« ${txt} »</blockquote></figure>`;
      }).join('');
    }
  }

  // opts (optionnel) : { size:'L' } pre-selectionne une taille, { floc:true } deplie d'emblee le menu Flocage
  // personnalise (quand le produit le permet). Utilise par les cartes du catalogue (clic taille / bouton panier).
  function openQV(id, opts) {
    opts = opts || {};
    const p = CATALOG.find(x => x.id === id); if (!p) return; qvP = p; const t = TEAM[p.team];
    renderGallery(p);
    lazyGallery(p);
    const bg = $('#qvBadge'); if (bg) bg.hidden = !p.isNew;
    $('#qvBrand').innerHTML = crestHTML(t) + `<span>${t.name} · ${LEAGUES[p.league]}</span>`;
    $('#qvName').textContent = p.title;
    $('#qvTags').innerHTML = `<span class="qv__tag">${p.sub}</span><span class="qv__tag">Saison ${p.season}</span>`;
    const _rev = (p.reviews != null ? p.reviews : 0) | 0;
    const _rateChip = _rev > 0 ? `<span class="qv__rate"><span class="star">★</span> ${String(p.rating).replace('.', ',')} <span class="qv__rev">(${_rev} avis)</span></span><span class="qv__sep" aria-hidden="true"></span>` : '';
    $('#qvSocial').innerHTML = `${_rateChip}<span class="qv__real"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>Photos réelles</span>`;
    const qvRev = $('#qvReviews'); if (qvRev) qvRev.innerHTML = reviewsHTML(p);
    lazyReviews(p);
    $('#qvPrice').textContent = eur(p.price);
    resetFloc(t);
    // flocage propose uniquement si l'album l'indique (champ floc issu du tag 'flocage')
    $('#floc').hidden = !p.floc;
    const sz = $('#qvSizes'); sz.innerHTML = '';
    // VRAIES tailles du produit affiche (enfant 16..28, adulte S..XXL) ; repli SIZES si absentes.
    const avail = (p.sizes && p.sizes.length) ? p.sizes.map(s => '' + s) : SIZES.slice();
    // taille par defaut : celle demandee (clic pill carte) si presente dans les tailles du produit,
    // sinon M si dispo, sinon la 1ere taille du produit (jamais une taille en dur).
    const reqSize = opts.size != null ? '' + opts.size : '';
    const def = (reqSize && avail.includes(reqSize)) ? reqSize : (avail.includes('M') ? 'M' : avail[0]);
    qvSize = def;
    avail.forEach(s => {
      const b = el(`<button class="size ${s === def ? 'is-on' : ''}" role="radio" aria-checked="${s === def}">${s}</button>`);
      b.addEventListener('click', () => { qvSize = s; $$('.size', sz).forEach(x => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b); }); });
      sz.appendChild(b);
    });
    qv.hidden = false; body.classList.add('is-locked'); trapFocus(qv.querySelector('.qv__panel') || qv);
    // depuis une carte (clic taille / bouton panier) : on deplie le menu Flocage pour que le client le voie d'emblee.
    if (opts.floc && p.floc) setFlocOpen(true);
  }
  function closeQV() { if (qv.hidden) return; qv.hidden = true; body.classList.remove('is-locked'); releaseFocus(); }
  $('#qvClose').addEventListener('click', closeQV); $('#qvScrim').addEventListener('click', closeQV);
  $('#qvAdd').addEventListener('click', () => { if (qvP) { const s = qvSize, p = qvP; const f = floc.on ? { name: floc.name.trim(), num: floc.num, bottom: floc.bottom.trim() } : null; closeQV(); addToCart(p, s, f); } });

  // --- flocage ludique : apercu en direct + presets joueurs + champs + ecusson ---
  function updatePreview() {
    $('#flocPvName').textContent = floc.name.trim() || 'TON NOM';
    $('#flocPvNum').textContent = (floc.num === '' || floc.num == null) ? '10' : floc.num;
    $('#flocPvBottom').textContent = floc.bottom.trim();
  }
  function updateQvPrice() { if (qvP) $('#qvPrice').textContent = eur(qvP.price + (floc.on ? FLOC_PRICE : 0)); }
  function setFlocOpen(open) {
    floc.on = open;
    $('#flocPanel').hidden = !open;
    $('#flocToggle').setAttribute('aria-expanded', open ? 'true' : 'false');
    $('#floc').classList.toggle('is-on', open);
    updateQvPrice();
    if (open) {
      requestAnimationFrame(() => { const f = $('#floc'); if (f) f.scrollIntoView({ block: 'start', behavior: 'smooth' }); });
      const n = $('#flocName'); if (n) setTimeout(() => { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }, 380);
    }
  }
  function resetFloc(team) {
    floc.on = false; floc.name = ''; floc.num = ''; floc.bottom = '';
    $('#flocName').value = ''; $('#flocNum').value = ''; $('#flocBottom').value = '';
    $('#flocPanel').hidden = true; $('#flocToggle').setAttribute('aria-expanded', 'false'); $('#floc').classList.remove('is-on');
    updatePreview();
    const presets = $('#flocPresets'); presets.innerHTML = '';
    const players = (team && team.players) ? team.players.slice(0, 3) : [];
    players.forEach(([name, num]) => {
      const short = name.split(' ').pop().toUpperCase().slice(0, 12);
      const b = el(`<button type="button" class="floc__preset"><b>${num}</b> ${short}</button>`);
      b.addEventListener('click', () => { if (!floc.on) setFlocOpen(true); floc.name = short; floc.num = String(num); $('#flocName').value = short; $('#flocNum').value = floc.num; updatePreview(); });
      presets.appendChild(b);
    });
    presets.hidden = players.length === 0;
  }
  function setupFloc() {
    $('#flocToggle').addEventListener('click', () => setFlocOpen($('#flocPanel').hidden));
    $('#flocName').addEventListener('input', e => { floc.name = e.target.value.toUpperCase(); e.target.value = floc.name; updatePreview(); });
    $('#flocBottom').addEventListener('input', e => { floc.bottom = e.target.value.toUpperCase(); e.target.value = floc.bottom; updatePreview(); });
    $('#flocNum').addEventListener('input', e => { let v = e.target.value.replace(/\D/g, '').slice(0, 2); if (v !== '' && +v > 99) v = '99'; e.target.value = v; floc.num = v; updatePreview(); });
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeQV(); closeCart(); closeSide(); } });

  // focus-trap accessible (modales + drawers) avec renvoi du focus
  let _trapEl = null, _trapH = null, _lastFocus = null;
  function trapFocus(container) {
    _lastFocus = document.activeElement; _trapEl = container;
    const SEL = 'a[href],button:not([disabled]),input:not([disabled]),select,[tabindex]:not([tabindex="-1"])';
    _trapH = (e) => {
      if (e.key !== 'Tab' || !_trapEl) return;
      const f = [...$$(SEL, _trapEl)].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', _trapH, true);
    const f = $$(SEL, container).filter(el => el.offsetParent !== null); if (f.length) f[0].focus();
  }
  function releaseFocus() {
    if (_trapH) { document.removeEventListener('keydown', _trapH, true); _trapH = null; }
    _trapEl = null; if (_lastFocus && _lastFocus.focus) { try { _lastFocus.focus(); } catch (e) {} } _lastFocus = null;
  }

  /* ----------------------------- panier (drawer reel) --------------- */
  /* panier delegue au socle commun (core.js) : etat persistant + tiroir partages */
  function updateCartCount() { }
  // resout l'ID de variante Shopify a partir de la taille (p.variants est une map { titre_variante: variantId }).
  // match exact, puis insensible casse/espaces, puis 1re variante dispo en repli -> jamais de ligne variantId:null.
  function resolveVariantId(p, size) {
    var v = p.variants;
    if (!v || typeof v !== 'object') return null;
    if (size != null && v[size] != null) return v[size];
    var want = String(size == null ? '' : size).trim().toLowerCase();
    var keys = Object.keys(v);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].trim().toLowerCase() === want) return v[keys[i]];
    }
    // repli : 1re variante disponible (produit mono-taille 'Default Title' / 'Unique', ou taille introuvable)
    return keys.length ? v[keys[0]] : null;
  }
  function addToCart(p, size, fl) {
    var vid = resolveVariantId(p, size);
    if (vid == null) { toast(cardTitle(p), 'Variante indisponible', 'Indisponible'); return; }
    LatakanCart.add({ id: p.id, variantId: vid, title: cardTitle(p), img: imgFor(p) || '', price: p.price, size: size, floc: fl });
    LatakanCore.openCart();
  }
  function openCart() { LatakanCore.openCart(); }
  function closeCart() { LatakanCore.closeCart(); }
  // synchronise toutes les instances d'un produit (grille + tendances + QV) avec le store
  function reflectFav(key, on) {
    $$('.fav').forEach(f => {
      if (f.dataset.fav !== key) return;
      f.classList.toggle('is-on', on);
      f.setAttribute('aria-pressed', on ? 'true' : 'false');
      f.setAttribute('aria-label', on ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }
  function toggleFav(p) {
    const key = wishKey(p);
    const on = Wish.toggle(favSnap(p)); // persiste + notifie core (compteur header/onglet)
    reflectFav(key, on);
    if (state.favOnly) afterChange(); // si on est dans la vue Favoris, rafraichir
  }
  // si la wishlist change ailleurs (autre onglet, page wishlist), refleter l'etat des coeurs
  Wish.subscribe(() => { $$('.fav').forEach(f => { const on = Wish.has(f.dataset.fav); f.classList.toggle('is-on', on); f.setAttribute('aria-pressed', on ? 'true' : 'false'); }); });
  function toast(title, sub, head) { LatakanCore.toast(title, sub, head); }
  $('#acctBtn').addEventListener('click', () => toast('Compte', 'Connexion bientot disponible', 'Ton compte'));

  /* ----------------------------- reset / mobile --------------------- */
  function resetAll() { [state.clubs, state.seasons, state.types, state.players, state.sizes].forEach(s => s.clear()); state.price = null; state.q = ''; state.collection = null; state.section = null; state.favOnly = false; qInput.value = ''; buildSidebar(); afterChange(); }
  $('#resetBtn').addEventListener('click', resetAll);
  $('#emptyReset').addEventListener('click', resetAll);
  $('.brand').addEventListener('click', () => { window.location.href = '/collections/all'; });
  const openSide = () => { $('#side').classList.add('is-open'); $('#sideScrim').classList.add('is-on'); body.classList.add('is-locked'); trapFocus($('#side')); };
  const closeSide = () => { if (!$('#side').classList.contains('is-open')) return; $('#side').classList.remove('is-open'); $('#sideScrim').classList.remove('is-on'); body.classList.remove('is-locked'); releaseFocus(); };
  $('#openFilters').addEventListener('click', openSide); $('#sideClose').addEventListener('click', closeSide); $('#sideScrim').addEventListener('click', closeSide);
  $('#sideApply').addEventListener('click', () => { closeSide(); const g = document.querySelector('.cat__bar') || grid; window.scrollTo({ top: Math.max(0, g.getBoundingClientRect().top + scrollY - 12), behavior: 'smooth' }); });

  /* ----------------------------- nav -------------------------------- */
  // Applique une "section" depuis une cle ?c= (all / selections / ldc / retro / flocages / limitées / clubs),
  // cote client, sans recharger. Reutilise par la nav header et le fil d'Ariane.
  const _SECTIONS = ['selections', 'ldc', 'retro', 'flocages', 'limitées'];
  function goSection(c) {
    resetAll();
    if (c === 'all' || c == null) state.section = 'all'; // vue "Tous les maillots" -> banniere dediee
    else if (c === 'clubs') { const cr = document.querySelector('.clubrow__wrap'); if (cr) window.scrollTo({ top: cr.offsetTop - 80, behavior: 'smooth' }); }
    else if (_SECTIONS.indexOf(c) >= 0) state.collection = c; // afterChange derive state.section depuis collection
    afterChange();
  }
  $$('.nav__link').forEach(a => a.addEventListener('click', e => {
    e.preventDefault(); const n = a.dataset.nav;
    const MAP = { retro: 'retro', players: 'flocages', nations: 'selections', ldc: 'ldc', all: 'all', clubs: 'clubs' };
    goSection(MAP[n] != null ? MAP[n] : 'all');
  }));

  /* ----------------------------- tab bar mobile --------------------- */
  function setTab(id) { $$('#tabbar .tabbar__b').forEach(b => { const on = b.dataset.tab === id; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); }); }
  $$('#tabbar [data-tab]').forEach(b => b.addEventListener('click', () => {
    const t = b.dataset.tab;
    if (t === 'home') { setTab('home'); resetAll(); state.collection = 'selections'; afterChange(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    else if (t === 'search') { setTab('search'); window.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(() => $('#q').focus(), 360); }
    else if (t === 'fav') { window.location.href = '/pages/wishlist'; }
    else if (t === 'cart') { window.location.href = '/cart'; }
  }));

  /* ----------------------------- top stats (topbar) ----------------- */
  // COMPTE CLUBS/SELECTIONS REEL : le header Liquid calcule un compte (nClubs) qui differe d'une unite
  // du compte du MOTEUR (classement club vs selection different) -> "57 clubs" alors que le moteur en
  // voit 58. On aligne le dernier <li> de #topStats sur le compte reel calcule par le moteur (source de
  // verite = la classification league des TEAMS, identique a la rangee clubs et aux vedettes).
  function updateTopStats() {
    const ul = document.getElementById('topStats'); if (!ul) return;
    const li = ul.lastElementChild; if (!li) return;
    const nClubs = TEAMS.filter(t => t.league !== 'nations').length;
    const nSel = TEAMS.filter(t => t.league === 'nations').length;
    li.innerHTML = '<b>' + nClubs + '</b>&nbsp;clubs, ' + nSel + ' sélections';
  }

  /* ----------------------------- init ------------------------------- */
  function init() {
    // #topStats : on recale le compte clubs/selections sur le compte reel du moteur (corrige l'off-by-one
    // du calcul Liquid). TEAMS est deja disponible (data inline), pas besoin d'attendre loadAll.
    updateTopStats();
    renderClubRow(); setupClubScroller(); renderHeroBanner(); renderVedettes(); setupFloc(); setupQVExtras(); renderCollRow();
    buildSidebar(); syncUI(); render();
    // filtre transmis par l'URL depuis la home (?c=<section>[&club=<handle>])
    const _params = new URLSearchParams(location.search);
    const _c = _params.get('c');
    const _club = _params.get('club');
    const _clubValid = _club && TEAM[_club]; // n'accepte qu'un handle d'equipe connu
    _urlReady = true; // a partir d'ici, les changements de vue peuvent ecrire l'URL (?c=)
    const _views = ['retro', 'flocages', 'limitées', 'selections', 'ldc'];
    if (_clubValid && (_c === 'all' || _views.includes(_c))) {
      // section competition (ou "tous") + club selectionne : la grille montre TOUS les maillots du club,
      // mais on garde la section pour le contexte (banniere + URL + retour F5).
      state.section = (_c === 'all') ? null : _c;
      state.collection = null; // grille = club entier (pas l'intersection section∩club, souvent vide)
      setVals(state.clubs, _club);
      afterChange();
    }
    else if (_c === 'all') { state.collection = null; state.section = 'all'; afterChange(); } // vue "tous les maillots" -> banniere dediee
    else if (_c && _views.includes(_c)) { state.collection = _c; afterChange(); } // afterChange derive state.section
    else if (_c === 'clubs') { const cr = document.querySelector('.clubrow__wrap'); if (cr) setTimeout(() => window.scrollTo({ top: cr.offsetTop - 80, behavior: 'smooth' }), 100); }
    else if (!_c && !_params.get('q') && !_params.get('qv')) { state.collection = null; state.section = 'all'; afterChange(); } // arrivee catalogue SANS ?c= : vue par defaut = Tous les maillots (banniere TM + grille complete). Coupe du Monde reste accessible via ?c=selections.
    // vue rapide deep-link : ?qv=<handle> (page Favoris) OU ?qv=team|imgk|season (reco panier).
    // Le produit peut ne pas etre dans le dump initial (250) -> on tente maintenant, puis a nouveau
    // apres loadAll() (cf. _qvDeepLink + appel en fin de loadAll). Introuvable apres loadAll : on ne fait rien.
    const _qv = new URLSearchParams(location.search).get('qv');
    if (_qv) { _qvPending = _qv; setTimeout(() => tryOpenQvDeepLink(), 0); }
    // anti-FOUC : le contenu dynamique a ete peuple (1er render) -> on revele tout d'un coup (fondu CSS).
    document.documentElement.classList.add('cat-ready');
  }
  // ouvre la vue rapide d'un produit a partir d'une cle stable team|imgk|season
  function openQVByKey(key) {
    if (!key) return false;
    const a = String(key).split('|');
    const p = CATALOG.find(x => x.team === a[0] && x.imgk === a[1] && x.season === a[2] && !x.player);
    if (!p) return false;
    openQV(p.id); return true;
  }
  // valeur du parametre ?qv en attente d'ouverture (le produit n'est peut-etre pas encore charge).
  let _qvPending = null;
  // tente d'ouvrir la vue rapide depuis ?qv : d'abord par handle (page Favoris : ?qv=<handle>),
  // sinon par cle team|imgk|season (reco panier). Renvoie true si la QV s'est ouverte.
  // Une fois ouverte, on purge le param de l'URL (replaceState) pour ne pas reouvrir au refresh.
  function tryOpenQvDeepLink() {
    const key = _qvPending;
    if (!key) return false;
    let opened = false;
    if (String(key).indexOf('|') >= 0) {
      opened = openQVByKey(key);
    } else {
      const p = CATALOG.find(x => x.handle === key);
      if (p) { openQV(p.id); opened = true; }
    }
    if (opened) {
      _qvPending = null;
      try { const u = new URL(location.href); u.searchParams.delete('qv'); history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash); } catch (e) {}
    }
    return opened;
  }
  init();
  // loadAll() complete le catalogue (>250) ; si ?qv n'a pas encore trouve son produit, on retente apres.
  loadAll().then(() => { if (_qvPending) tryOpenQvDeepLink(); }).catch(() => { if (_qvPending) tryOpenQvDeepLink(); });
  window.LatakanCatalogue = { state, get CATALOG() { return CATALOG; }, TEAMS, COLLECTIONS, render, selectClub, setCollection, resetAll, openQV, openQVByKey };
})();
